@if (depositNotAvailableMessage) {
    <show-message id="depositNotAvailableMessage" [type]="messageType.ERROR">
        <p error>{{ 'PARTY.CASHIER.web.deposit.notavailble' | translate }}</p>
    </show-message>
}

@if (showDeclineError) {
    <show-message id="decline-error-qd" [type]="messageType.ERROR">
        <div error>
            @if (errorTemplate?.header) {
                <strong>{{ errorTemplate.header }}</strong>
            }
            <p>{{ errorTemplate?.description }}</p>
        </div>
    </show-message>
} @else if ((error || errorDetails) && !kycDetails) {
    <show-message id="noKycDetails" [type]="messageType.ERROR">
        <div error>
            <strong style="text-transform: none">{{ 'PARTY.CASHIER.web.deposit.decline.message1.v3.header' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.deposit.decline.message1.v3.text' | translate }}</p>
        </div>
    </show-message>
}

@if (kycDetails) {
    <div>
        <show-message [type]="messageType.ERROR">
            <div error>
                <div>
                    @switch (kycDetails.errorResponse?.errorMessage) {
                        @case ('KYC_LIMIT_EXCEEDED') {
                            <div>
                                @if (IsSwedenFE) {
                                    <div>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.kyc.limit.exceededsweden'
                                                    | translate
                                                        : {
                                                              kycDepositLimit:
                                                                  kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                    </div>
                                }
                                @if (isDEUJurisdiction) {
                                    <div>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.de.limit.exceeded.msg'
                                                    | translate
                                                        : {
                                                              kycDepositLimit:
                                                                  kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.de.sofort.msg'
                                                    | translate
                                                        : {
                                                              kycDepositLimit:
                                                                  kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                        <p>
                                            <a href="{{ kycDetails.kycRedirectionUrlInfo.url }}" target="_top">
                                                <b>{{ 'PARTY.CASHIER.web.deposit.de.limit.another.option' | translate }}</b></a
                                            >.
                                        </p>
                                        @if (isDepositAllowedOnOtherProduct) {
                                            <div>
                                                <p>
                                                    {{
                                                        'PARTY.CASHIER.web.deposit.de.proposed.product.msg'
                                                            | translate
                                                                : {
                                                                      product: proposedProduct,
                                                                  }
                                                    }}
                                                </p>
                                            </div>
                                        }
                                    </div>
                                }
                                @if (IsGreeceFE) {
                                    <div>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.kyc.limit.exce.gbr'
                                                    | translate
                                                        : {
                                                              kycDepositLimit:
                                                                  kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                    </div>
                                }
                                @if (!isDEUJurisdiction) {
                                    <div>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.kyc.limit.exce.irl'
                                                    | translate
                                                        : {
                                                              kycDepositLimit:
                                                                  kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                    </div>
                                }
                            </div>
                        }
                        @case ('KYC_LIMIT_TO_BE_EXCEEDED') {
                            <div>
                                @if (isDEUJurisdiction) {
                                    <div>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.de.limit.tobe.exceededmsg'
                                                    | translate
                                                        : {
                                                              kycDepositLimit:
                                                                  kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.de.limit.tobe.exceeded1msg'
                                                    | translate
                                                        : {
                                                              product: productToShow,
                                                          }
                                            }}
                                        </p>
                                        <p>{{ 'PARTY.CASHIER.web.deposit.de.limit.tobe.exceeded3' | translate }}</p>
                                    </div>
                                }
                                @if (!isDEUJurisdiction && kycDetails.errorResponse.templateName != 'deposit_kyc_limit_exceeded') {
                                    <div>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.kyc.limit.tobe.exceeded'
                                                    | translate
                                                        : {
                                                              kycDepositLimit:
                                                                  kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                              allowedDepLimit:
                                                                  kycDetails.kycRemainingLimit?.value
                                                                  | vnCurrency: kycDetails.kycRemainingLimit?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                    </div>
                                }
                                @if (!isDEUJurisdiction && kycDetails.errorResponse.templateName == 'deposit_kyc_limit_exceeded') {
                                    <div>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.kyc.limit.tobe.exceed.sb'
                                                    | translate
                                                        : {
                                                              kycDepositLimit:
                                                                  kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                              kycStandardLimit:
                                                                  kycDetails.additionalInfo?.kycStandardLimitAmount
                                                                  | vnCurrency: kycDetails.additionalInfo?.kycStandardLimitCurrency,
                                                              allowedDepLimit:
                                                                  kycDetails.kycRemainingLimit?.value
                                                                  | vnCurrency: kycDetails.kycRemainingLimit?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                    </div>
                                }
                            </div>
                        }
                        @case ('KYC_LIMIT_EXHAUSTED') {
                            <div>
                                <p>
                                    {{
                                        'PARTY.CASHIER.web.deposit.kyc.limit.exce.gbr'
                                            | translate
                                                : {
                                                      kycDepositLimit: kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                  }
                                    }}
                                </p>
                            </div>
                        }
                        @case ('KYC_GRACEPERIOD_COMPLETED') {
                            <div>
                                @if (isDEUJurisdiction) {
                                    <div>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.de.sofort.msg'
                                                    | translate
                                                        : {
                                                              kycDepositLimit:
                                                                  kycDetails.kycLimit?.value | vnCurrency: kycDetails.kycLimit?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                        <span
                                            ><a href="{{ kycDetails.kycRedirectionUrlInfo.url }}" target="_top">
                                                <b>{{ 'PARTY.CASHIER.web.deposit.de.limit.another.option' | translate }}</b></a
                                            >.</span
                                        >
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.deposit.de.proposed.product.msg'
                                                    | translate
                                                        : {
                                                              product: proposedProduct,
                                                          }
                                            }}
                                        </p>
                                    </div>
                                }
                                @if (!isDEUJurisdiction) {
                                    <p>
                                        {{ 'PARTY.CASHIER.web.deposit.kyc.graceperiod.completed' | translate }}
                                    </p>
                                }
                            </div>
                        }
                    }
                </div>
            </div>
        </show-message>
        <div>
            @switch (kycDetails.kycRedirectionUrlInfo?.target) {
                @case ('postActionMessage') {
                    <div>
                        <button
                            (click)="postActionMessage(kycDetails.kycRedirectionUrlInfo?.url)"
                            id="postActionMessage"
                            type="button"
                            class="btn btn-alt">
                            {{ 'PARTY.CASHIER.web.deposit.kyc.verify.message' | translate }}
                        </button>
                    </div>
                }
                @case ('postAppMessage') {
                    <div>
                        <button (click)="postAppMessage(kycDetails.kycRedirectionUrlInfo?.url)" id="postAppMessage" type="button" class="btn btn-alt">
                            {{ 'PARTY.CASHIER.web.deposit.kyc.verify.message' | translate }}
                        </button>
                    </div>
                }
                @default {
                    <div>
                        <a
                            href="{{ kycDetails.kycRedirectionUrlInfo?.url }}"
                            id="postDefaultMsg"
                            target="_top"
                            type="button"
                            class="btn btn-primary w-100 mb-2"
                            >{{ 'PARTY.CASHIER.web.deposit.kyc.verify.message' | translate }}</a
                        >
                    </div>
                }
            }
        </div>
    </div>
}

@if (CentralDepLimitsErrorDetails) {
    <show-message id="centralDepLimitsErrorDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.qd.centraldeplimit.exceeded.header' | translate }} </strong>
            @if (ExceededCase) {
                <p>
                    {{
                        'PARTY.CASHIER.web.deposit.qd.centraldeplimit.exceeded.message'
                            | translate
                                : {
                                      remainingAmount:
                                          CentralDepLimitsErrorDetails?.errorResponse?.remainingAmount
                                          | vnCurrency: CentralDepLimitsErrorDetails?.amount?.currencyCode,
                                  }
                    }}
                </p>
            }
            @if (!ExceededCase) {
                <p>{{ 'PARTY.CASHIER.web.deposit.qd.centraldeplimit.exhausted.message' | translate }}</p>
            }
        </div>
    </show-message>
}

@if (cdrMessagesErrorDetails) {
    <show-message id="cdrMessagesErrorDetails" [type]="messageType.ERROR">
        <div error>
            @if (['THIRDPARTY_ERROR', 'PLAYER_NOT_REGISTERED'].includes(cdrMessagesErrorDetails.errorMessage)) {
                <div>
                    @if (cdrMessagesErrorDetails.txnState == 'refund') {
                        <div>
                            <strong>{{ 'PARTY.CASHIER.web.deposit.qd.centraldeplimit.exceeded.header' | translate }}</strong>
                            <p>
                                {{
                                    'PARTY.CASHIER.web.deposit.decline.message2.refund.cdr.message'
                                        | translate
                                            : {
                                                  paymentMethod: paymentMethod,
                                              }
                                }}
                            </p>
                        </div>
                    }
                    @if (cdrMessagesErrorDetails.txnState == 'reject') {
                        <div>
                            <strong>{{ 'PARTY.CASHIER.web.deposit.decline.message2.cdr.header' | translate }}</strong>
                            <p>{{ 'PARTY.CASHIER.web.deposit.decline.message2.rejected.cdr.message' | translate }}</p>
                        </div>
                    }
                </div>
            }
        </div>
    </show-message>
}

@if (depositService.paypalDirectBadFunding) {
    <show-message id="paypalDirectBadFunding" [type]="messageType.ERROR">
        <div error>
            <div>
                <strong>{{ 'PARTY.CASHIER.web.deposit.decline.message1.v3.header' | translate }}</strong>
                @if (depositService.paypalDirectBadFunding?.errorMessage == '2046 : INSUFFICIENT_FUNDS') {
                    <p>
                        {{ 'PARTY.CASHIER.web.deposit.paypaldirect.2046.insufficientFunds.text' | translate }}
                    </p>
                }
                @if (['2046 : TRANSACTION_REFUSED', '2046 : INSTRUMENT DECLINED'].includes(depositService.paypalDirectBadFunding?.errorMessage)) {
                    <p>
                        {{ 'PARTY.CASHIER.web.deposit.paypaldirect.2046.instrumentDecline.text' | translate }}
                    </p>
                }
            </div>
        </div>
    </show-message>
}

@if (doNotHonorErrorDetails) {
    <show-message id="doNotHonorErrorDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.decline.message1.v3.header' | translate }}</strong>
            @if (!isUSLabel) {
                <p>{{ 'PARTY.CASHIER.web.deposit.error.DepositDecline.DonotHonour' | translate }}</p>
            }
            @if (isUSLabel) {
                <p>{{ 'PARTY.CASHIER.web.deposit.error.DepositDecline.DonotHonour.US' | translate }}</p>
            }
        </div>
    </show-message>
}

@if (insufficientFundsErrorDetails) {
    <show-message id="insufficientFundsErrorDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.decline.message1.v3.header' | translate }}</strong>
            @if (!isUSLabel) {
                <p>{{ 'PARTY.CASHIER.web.deposit.insuffientfunds.text' | translate }}</p>
            }
            @if (isUSLabel) {
                <p>{{ 'PARTY.CASHIER.web.deposit.insuffientfunds.text.US' | translate }}</p>
            }
        </div>
    </show-message>
}

@if (invalidCvvErrorDetails) {
    <show-message id="invalidCvvErrorDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.decline.message1.v3.header' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.deposit.invalidCvv.text' | translate }}</p>
        </div>
    </show-message>
}

@if (internalErrorDetails) {
    <show-message id="internalErrorDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.decline.message1.v3.header' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.deposit.internalErrorDetails.text' | translate }}</p>
        </div>
    </show-message>
}

@if (arcDepositDecline) {
    <show-message id="arcDepositDecline" [type]="messageType.INFO">
        <div info>
            <strong>{{ 'PARTY.CASHIER.web.arc.deposit.limits.interaction.msg.header' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.arc.deposit.limits.interaction.bmsg1' | translate }}</p>
            <p>{{ 'PARTY.CASHIER.web.arc.deposit.limits.interaction.bmsg2' | translate }}</p>
            <br />
            <span>
                <b class="space-between mb-2">
                    <a (click)="closeQD()" id="closeQD">
                        {{ 'PARTY.CASHIER.web.arc.deposit.limits.interaction.msg.btn.adjust.amount' | translate }}
                    </a>
                    <a (click)="submitArcDeposit()" id="submitArcDeposit"> {{ 'PARTY.CASHIER.web.continue' | translate }} </a></b
                >
            </span>
        </div>
    </show-message>
}

@if (amlNetDepLimitErrorDetails) {
    <div>
        <div>
            @switch (amlNetDepLimitErrorDetails?.templateName) {
                @case ('aml_limit_exceeded') {
                    <div>
                        <show-message id="amlNetDepLimitErrorDetailsaml_limit_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong>{{
                                    'PARTY.CASHIER.web.deposit.affordibility.limit.exceeded.header'
                                        | translate
                                            : {
                                                  netDepLimit:
                                                      amlNetDepLimitErrorDetails?.netDepLimit
                                                      | vnCurrency: amlNetDepLimitErrorDetails?.accountCurrency,
                                              }
                                }}</strong>
                                <p>
                                    {{ 'PARTY.CASHIER.web.deposit.affordibility.limit.exceeded.msg' | translate }}
                                    <a href="mailto:{{ amlNetDepLimitErrorDetails?.contactEmail }}" target="_top">{{
                                        amlNetDepLimitErrorDetails?.contactEmail
                                    }}</a>
                                </p>
                            </div>
                        </show-message>
                    </div>
                }
                @case ('aml_limit_to_be_exceeded') {
                    <div>
                        <show-message id="amlNetDepLimitErrorDetailsaml_limit_to_be_exceeded" [type]="messageType.INFO">
                            <div info>
                                <strong>{{
                                    'PARTY.CASHIER.web.deposit.affordibility.limit.tobeexceeded.header'
                                        | translate
                                            : {
                                                  netDepLimit:
                                                      amlNetDepLimitErrorDetails?.netDepLimit
                                                      | vnCurrency: amlNetDepLimitErrorDetails?.accountCurrency,
                                              }
                                }}</strong>
                                <p>
                                    {{ 'PARTY.CASHIER.web.deposit.affordibility.limit.tobeexceeded.msg' | translate }}
                                    <a href="mailto:{{ amlNetDepLimitErrorDetails?.contactEmail }}" target="_top">{{
                                        amlNetDepLimitErrorDetails?.contactEmail
                                    }}</a>
                                </p>
                            </div>
                        </show-message>
                    </div>
                }
                @default {
                    <div>
                        <show-message id="amlNetDepLimitErrorDetailsaml_default" [type]="messageType.INFO">
                            <div info>
                                <strong>
                                    {{ 'PARTY.CASHIER.web.svoc.161.header1' | translate }}
                                </strong>
                                <p>
                                    @if (!isCountryUK) {
                                        <span>
                                            {{
                                                'PARTY.CASHIER.web.svoc.161.message1'
                                                    | translate
                                                        : {
                                                              phoneNumber: amlNetDepLimitErrorDetails?.contactUsPhone,
                                                          }
                                            }}
                                        </span>
                                    }
                                    @if (isCountryUK) {
                                        <span>
                                            {{
                                                'PARTY.CASHIER.web.svoc.161.message1.uk'
                                                    | translate
                                                        : {
                                                              phoneNumber: amlNetDepLimitErrorDetails?.contactUsPhone,
                                                          }
                                            }}
                                        </span>
                                    }
                                    <b> <u (click)="triggerChat('chat link')" id="chat">chat</u></b>
                                    {{ 'PARTY.CASHIER.web.svoc.161.message3' | translate }}
                                    <a href="mailto:{{ amlNetDepLimitErrorDetails?.contactEmail }}" target="_top">{{
                                        amlNetDepLimitErrorDetails?.contactEmail
                                    }}</a>
                                    {{ 'PARTY.CASHIER.web.svoc.161.message2' | translate }}
                                </p>
                            </div>
                        </show-message>
                        @if (showChatCTA && !hideChat) {
                            <div>
                                <button (click)="triggerChat('chat here cta')" id="ChatCTA" type="button" class="btn btn-primary">
                                    {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                                </button>
                            </div>
                        }
                    </div>
                }
            }
        </div>
    </div>
}

@if (prorgDepLimitErrorDetails) {
    <div>
        <div>
            @switch (prorgDepLimitErrorDetails?.errorMessage?.toLowerCase()) {
                @case (
                    ['deposit_12months_limit_exceeded', 'hardstop_o80_limit_exceeded'].includes(
                        prorgDepLimitErrorDetails?.errorMessage?.toLowerCase()
                    )
                        ? prorgDepLimitErrorDetails?.errorMessage?.toLowerCase()
                        : ''
                ) {
                    <div id="hardStopchatUrl">
                        <show-message id="prorgDepLimitErrorDetailsdeposit_12months_limit_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong
                                    (click)="monthlyLimit($event, 'annual loss limit link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.yearly.affordibility.limit.exceeded.header'
                                            | translate
                                                : {
                                                      netDepLimit: prorgDepLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      hardstopInfoLink: prorgDepLimitErrorDetails?.hardstopInfoLink,
                                                  }
                                    ">
                                </strong>
                                <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.hardstop.limit.text1' | translate }}</p>
                                <p
                                    class="line-space"
                                    (click)="contactUsLink($event, 'chat with us link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.deposit.hardstop.limit.text2' | translate: { url: prorgDepLimitErrorDetails.contactUs }
                                    "></p>
                            </div>
                        </show-message>
                    </div>
                }
                @case (
                    ['deposit_12months_limit_to_be_exceeded', 'hardstop_o80_limit_to_be_exceeded'].includes(
                        prorgDepLimitErrorDetails?.errorMessage?.toLowerCase()
                    )
                        ? prorgDepLimitErrorDetails?.errorMessage?.toLowerCase()
                        : ''
                ) {
                    <div id="hardStopchatUrl">
                        <show-message id="prorgDepLimitErrorDetailsdeposit_12months_limit_to_be_exceeded" [type]="messageType.INFO">
                            <div info>
                                <strong
                                    (click)="monthlyLimit($event, 'annual loss limit link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.yearly.affordibility.limit.tobeexceeded.header'
                                            | translate
                                                : {
                                                      netDepLimit: prorgDepLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      hardstopInfoLink: prorgDepLimitErrorDetails?.hardstopInfoLink,
                                                  }
                                    ">
                                </strong>
                                <p class="line-space">
                                    {{
                                        'PARTY.CASHIER.web.172.limit.to.be.reached.msg3'
                                            | translate
                                                : {
                                                      remainingamount:
                                                          prorgDepLimitErrorDetails?.allowedAmt?.value
                                                          | vnCurrency: prorgDepLimitErrorDetails?.allowedAmt?.currencyCode,
                                                  }
                                    }}
                                </p>
                                <p class="line-space">
                                    {{ 'PARTY.CASHIER.web.deposit.hardstop.limit.text1' | translate }}
                                </p>
                                <p
                                    class="line-space"
                                    (click)="contactUsLink($event, 'chat with us link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.deposit.hardstop.limit.text2' | translate: { url: prorgDepLimitErrorDetails.contactUs }
                                    "></p>
                            </div>
                        </show-message>
                    </div>
                }
                @case ('deposit_12months_limit_exceeded_bea') {
                    <div id="hardStopchatUrl">
                        <show-message id="prorgDepLimitErrorDetailsdeposit_12months_limit_exceeded_bea" [type]="messageType.ERROR">
                            <div error>
                                <strong
                                    (click)="monthlyLimit($event, 'loss limit link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.deposit.hardstop.limit.header.bea'
                                            | translate
                                                : {
                                                      limit: prorgDepLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      age: prorgDepLimitErrorDetails?.hardstopUnderAgeValue,
                                                      hardstopInfoLink: prorgDepLimitErrorDetails?.hardstopInfoLink,
                                                  }
                                    ">
                                </strong>
                                <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.hardstop.limit.text1' | translate }}</p>
                                <p
                                    class="line-space"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.exceeded.msg2'
                                            | translate: { playerProtectionEmail: prorgDepLimitErrorDetails?.playerProtectionEmail }
                                    "></p>
                            </div>
                        </show-message>
                    </div>
                }
                @case ('deposit_12months_limit_to_be_exceeded_bea') {
                    <div id="hardStopchatUrl">
                        <show-message id="prorgDepLimitErrorDetailsdeposit_12months_limit_exceeded_bea" [type]="messageType.INFO">
                            <div info>
                                <strong
                                    (click)="monthlyLimit($event, 'loss limit link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.deposit.hardstop.limit.header.bea2'
                                            | translate
                                                : {
                                                      limit: prorgDepLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      age: prorgDepLimitErrorDetails?.hardstopUnderAgeValue,
                                                      hardstopInfoLink: prorgDepLimitErrorDetails?.hardstopInfoLink,
                                                  }
                                    ">
                                </strong>
                                <p class="line-space">
                                    {{
                                        'PARTY.CASHIER.web.172.limit.to.be.reached.msg3'
                                            | translate
                                                : {
                                                      remainingamount:
                                                          prorgDepLimitErrorDetails?.allowedAmt?.value
                                                          | vnCurrency: prorgDepLimitErrorDetails?.allowedAmt?.currencyCode,
                                                  }
                                    }}
                                </p>
                                <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.hardstop.limit.text1' | translate }}</p>
                                <p
                                    class="line-space"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.exceeded.msg2'
                                            | translate: { playerProtectionEmail: prorgDepLimitErrorDetails?.playerProtectionEmail }
                                    "></p>
                            </div>
                        </show-message>
                    </div>
                }
                @case ('deposit_30days_limit_exceeded') {
                    <div id="hardStopchatUrl">
                        <show-message id="prorgDepLimitErrorDetailsdeposit_30days_limit_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong>
                                    {{
                                        'PARTY.CASHIER.web.deposit.hardstop.limit.header.fm'
                                            | translate
                                                : {
                                                      limit: prorgDepLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                  }
                                    }}
                                </strong>
                                @if (!isCountryUK) {
                                    <p>
                                        {{
                                            'PARTY.CASHIER.web.monthly.hardstop.limit.exceeded'
                                                | translate
                                                    : {
                                                          phoneNumber: prorgDepLimitErrorDetails?.contactUsNumber,
                                                      }
                                        }}
                                    </p>
                                }
                                @if (isCountryUK) {
                                    <p>
                                        {{
                                            'PARTY.CASHIER.web.monthly.hardstop.limit.exceeded.uk'
                                                | translate
                                                    : {
                                                          phoneNumber: prorgDepLimitErrorDetails?.contactUsNumber,
                                                      }
                                        }}
                                    </p>
                                }
                            </div>
                        </show-message>
                    </div>
                }
                @case ('deposit_30days_limit_to_be_exceeded') {
                    <div id="hardStopchatUrl">
                        <show-message id="prorgDepLimitErrorDetailsdeposit_30days_limit_to_be_exceeded" [type]="messageType.INFO">
                            <div info>
                                <strong
                                    >{{
                                        'PARTY.CASHIER.web.deposit.hardstop.limit.header.fm2'
                                            | translate
                                                : {
                                                      limit: prorgDepLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                  }
                                    }}
                                </strong>
                                @if (!isCountryUK) {
                                    <p>
                                        {{
                                            'PARTY.CASHIER.web.svoc.harstop.monthly.limit.tobeexceeded'
                                                | translate
                                                    : {
                                                          limit:
                                                              prorgDepLimitErrorDetails?.allowedAmt?.value
                                                              | vnCurrency: prorgDepLimitErrorDetails?.allowedAmt?.currencyCode,
                                                          phoneNumber: prorgDepLimitErrorDetails?.contactUsNumber,
                                                      }
                                        }}
                                    </p>
                                }
                                @if (isCountryUK) {
                                    <p>
                                        {{
                                            'PARTY.CASHIER.web.svoc.harstop.monthly.limit.tobeexceeded.uk'
                                                | translate
                                                    : {
                                                          limit:
                                                              prorgDepLimitErrorDetails?.allowedAmt?.value
                                                              | vnCurrency: prorgDepLimitErrorDetails?.allowedAmt?.currencyCode,
                                                          phoneNumber: prorgDepLimitErrorDetails?.contactUsNumber,
                                                      }
                                        }}
                                    </p>
                                }
                                <p>
                                    <b
                                        ><u (click)="triggerChat('chat with us link')" id="svocChat" style="cursor: pointer">{{
                                            'PARTY.CASHIER.web.svoc.chat.text' | translate
                                        }}</u></b
                                    >.
                                </p>
                            </div>
                        </show-message>
                    </div>
                }
            }
        </div>
        @if (!['152', '189'].includes(prorgDepLimitErrorDetails?.errorCode)) {
            @if (showChatCTA && !showChatNotAvailable && !hideChat) {
                <div>
                    <button (click)="triggerChat('chat here cta')" id="liveHelp" type="button" class="btn btn-chat btn-lg theme-chat w-100 mb-2">
                        {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                    </button>
                </div>
            }
            @if (showChatNotAvailable) {
                <div>
                    <div class="live-help zendesk-live-block form-control">
                        <a href="javascript:void(0)" class="btn btn-chat btn-lg theme-chat w-100 mb-2">
                            {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                        </a>
                        <div class="zendesk-live-block">{{ 'PARTY.CASHIER.web.deposit.chat.zendesk.text' | translate }}</div>
                    </div>
                </div>
            }
        }
    </div>
}

@if (belgiumAffLimitsErrorDetails?.errorCode == 126) {
    <div>
        @if (isBelgiumLimitAvailable) {
            <show-message id="isBelgiumLimitAvailable" [type]="messageType.INFO">
                <div info>
                    <strong
                        >{{
                            'PARTY.CASHIER.web.deposit.belgium.aff.limits.header'
                                | translate
                                    : {
                                          BelgiumLimit: maxPurchaseLimit | vnCurrency: currencyEUR,
                                      }
                        }}
                    </strong>
                    <p>
                        {{
                            'PARTY.CASHIER.web.deposit.belgium.aff.limits.description'
                                | translate
                                    : {
                                          BelgiumLimit: maxPurchaseLimit | vnCurrency: currencyEUR,
                                      }
                        }}
                    </p>
                    <p>
                        {{
                            'PARTY.CASHIER.web.deposit.belgium.aff.limits.time'
                                | translate
                                    : {
                                          availableBelgiumLimit: availableBelgiumLimit | vnCurrency: currencyEUR,
                                      }
                        }}
                    </p>
                </div>
            </show-message>
        }
        @if (belgiumAffLimitsErrorDetails?.nextDateToShow) {
            <show-message id="belgiumAffLimitsErrorDetails_nextDateToShow" [type]="messageType.ERROR">
                <div error>
                    <strong>
                        {{
                            'PARTY.CASHIER.web.deposit.belgium.aff.exceeded.limits.header'
                                | translate
                                    : {
                                          BelgiumLimit: maxPurchaseLimit | vnCurrency: currencyEUR,
                                      }
                        }}
                    </strong>
                    <p>
                        {{
                            'PARTY.CASHIER.web.deposit.belgium.aff.exceeded.limits.description'
                                | translate
                                    : {
                                          BelgiumLimit: maxPurchaseLimit | vnCurrency: currencyEUR,
                                      }
                        }}
                    </p>
                    <p>
                        {{
                            'PARTY.CASHIER.web.deposit.belgium.aff.exceeded.limits.time'
                                | translate
                                    : {
                                          nextDate: nextDate.substring(0, 10),
                                          time: nextDate.substring(nextDate.length - 5),
                                      }
                        }}
                    </p>
                </div>
            </show-message>
        }
    </div>
}

@if (sportsLimitsErrorDetails) {
    <show-message id="sportsLimitsErrorDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.sportslimitsexceeded.header.message1' | translate }}</strong>
            <p
                [vnDynamicHtml]="
                    'PARTY.CASHIER.web.deposit.sportslimitsexceeded.monthly.message3'
                        | translate
                            : {
                                  helpUrl: sportsLimitIncreaseUrl,
                              }
                "></p>
            @if (isGamesProductSupported && paymentMethod != 'PAYPAL') {
                <p>
                    {{ 'PARTY.CASHIER.web.deposit.sportslimitsexceeded.monthly.message4' | translate }}
                </p>
            }
        </div>
    </show-message>
}

@if (gamingLimitsErrorDetails) {
    <show-message id="gamingLimitsErrorDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.gaminglimitsexceeded.header.message' | translate }}</strong>
            @if (isCasinoAndPokerProductError) {
                <p
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.deposit.gaminglimitsexceeded.monthly.message1'
                            | translate
                                : {
                                      depositLimitsUrlError: depositLimitsUrlError,
                                  }
                    "></p>
            }
            @if (!isCasinoAndPokerProductError && isCasinoProductError) {
                <p
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.deposit.gaminglimitsexceeded.monthly.message2'
                            | translate
                                : {
                                      depositLimitsUrlError: depositLimitsUrlError,
                                  }
                    "></p>
            }
            @if (!isCasinoAndPokerProductError && isPokerProductError) {
                <p
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.deposit.gaminglimitsexceeded.monthly.message3'
                            | translate
                                : {
                                      depositLimitsUrlError: depositLimitsUrlError,
                                  }
                    "></p>
            }
            @if (isSportsProductSupported) {
                <p>
                    {{ 'PARTY.CASHIER.web.deposit.gaminglimitsexceeded.monthly.message4' | translate }}
                </p>
            }
        </div>
    </show-message>
}

@if (
    !isGbgVerified &&
    gamingLimitsNotConfigured &&
    (productSelectedError == 'POKER' || productSelectedError == 'CASINO') &&
    (isPokerProductError || isCasinoAndPokerProductError || isCasinoProductError)
) {
    <show-message id="gamingLimitsNotConfigured" [type]="messageType.ERROR">
        <div error>
            @if (isCasinoAndPokerProductError) {
                <p>
                    {{ 'PARTY.CASHIER.web.deposit.gaminglimit.casinoandpoker.message' | translate }}
                    &nbsp;<a href="{{ depositLimitsUrlError }}" target="_top">
                        <u>{{ 'PARTY.CASHIER.web.deposit.deposit.limits.set' | translate }}</u>
                    </a>
                </p>
            }
            @if (!isCasinoAndPokerProductError && isCasinoProductError) {
                <p>
                    {{ 'PARTY.CASHIER.web.deposit.gaminglimit.casino.message' | translate }} &nbsp;<a
                        href="{{ depositLimitsUrlError }}"
                        target="_top">
                        <u>{{ 'PARTY.CASHIER.web.deposit.deposit.limits.set' | translate }}</u>
                    </a>
                </p>
            }
            @if (!isCasinoAndPokerProductError && isPokerProductError) {
                <p>
                    {{ 'PARTY.CASHIER.web.deposit.gaminglimit.poker.message' | translate }} &nbsp;<a href="{{ depositLimitsUrlError }}" target="_top">
                        <u>{{ 'PARTY.CASHIER.web.deposit.deposit.limits.set' | translate }}</u>
                    </a>
                </p>
            }
        </div>
    </show-message>
}

@if (creditCardBlockDetails) {
    <show-message id="creditCardBlockDetails" [type]="messageType.ERROR">
        <div error>
            <span>
                @switch (creditCardBlockDetails?.errorMessage) {
                    @case ('CC_DEPOSIT_BLOCK') {
                        <p>{{ 'PARTY.CASHIER.web.deposit.card.blocked.msg1' | translate }}</p>
                    }
                    @case ('CC_DEPOSIT_BLOCK_COOLOFF') {
                        <div>
                            <p>{{ 'PARTY.CASHIER.web.deposit.card.blocked.msg1' | translate }}</p>
                            <p>{{ 'PARTY.CASHIER.web.deposit.card.blocked.coolOff' | translate }}</p>
                        </div>
                    }
                }
            </span>
        </div>
    </show-message>
}

@if (gamerscardErrorCodeDetails) {
    <show-message id="gamerscardErrorCodeDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.decline.message1.v3.text' | translate }}</strong>
            <div>
                @switch (gamerscardErrorCodeDetails?.errorCode) {
                    @case (1000) {
                        <p>{{ 'PARTY.CASHIER.web.deposit.gamerscard.error.1000.message' | translate }}</p>
                    }
                    @case (1001) {
                        <p>{{ 'PARTY.CASHIER.web.deposit.gamerscard.error.1001.message' | translate }}</p>
                    }
                    @case (2000) {
                        <p>{{ 'PARTY.CASHIER.web.deposit.gamerscard.error.2000.message' | translate }}</p>
                    }
                    @case (2001) {
                        <p>{{ 'PARTY.CASHIER.web.deposit.gamerscard.error.2001.message' | translate }}</p>
                    }
                    @case (2003) {
                        <p>{{ 'PARTY.CASHIER.web.deposit.gamerscard.error.2003.message' | translate }}</p>
                    }
                    @case (2005) {
                        <p>{{ 'PARTY.CASHIER.web.deposit.gamerscard.error.2005.message' | translate }}</p>
                    }
                }
            </div>
        </div>
    </show-message>
}

@if (intensivePlayerMessage) {
    <show-message id="intensivePlayerMessage" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.intensive.player.message1' | translate }}</strong>
            <p [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.intensive.player.message2' | translate"></p>
            <a (click)="moreInfoLink()"
                ><span class="float-right"
                    ><b>{{ 'PARTY.CASHIER.web.deposit.intensive.player.message3' | translate }}</b></span
                ></a
            >
        </div>
    </show-message>
}
@if (riskPlayerMessage) {
    <show-message id="riskPlayerMessage" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.risk.player.message1' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.deposit.risk.player.message' | translate }}</p>
            <a (click)="liveChatUrlRisky()"
                ><span class="float-right"
                    ><b>{{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.liveChat' | translate }}</b></span
                ></a
            >
        </div>
    </show-message>
}
@if (ParRiskFailureErrorDetails) {
    <show-message id="parRiskFailureMessage" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.par.riskCheck.failure.header' | translate }}</strong>
            <p [vnDynamicHtml]="errorDescription"></p>
        </div>
    </show-message>
}
@if (showAchIntercheksMessage) {
    <show-message id="interchecks_ach" [type]="messageType.ERROR">
        <div error>
            <div [vnDynamicHtml]="errorDescription"></div>
        </div>
    </show-message>
}
@if (affordibilityMonthlyNetDepLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibilityMonthlyNetDepLimitErrorDetails?.templateName) {
                @case ('aml_limit_exceeded') {
                    <div>
                        <show-message id="affordibilityMonthly_aml_limit_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong
                                    >{{
                                        'PARTY.CASHIER.web.deposit.affordibility.limit.exceeded.header2'
                                            | translate
                                                : {
                                                      netDepLimit: affordibilityMonthlyNetDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                  }
                                    }}
                                </strong>
                                @if (!isCountryUK) {
                                    <p>
                                        {{ 'PARTY.CASHIER.web.monthly.affordibility.limit.exceeded.msg1' | translate }}
                                    </p>
                                }
                                @if (isCountryUK) {
                                    <p>
                                        {{ 'PARTY.CASHIER.web.monthly.affordibility.limit.exceeded.msg1.uk' | translate }}
                                        <a href="mailto:{{ affordibilityMonthlyNetDepLimitErrorDetails?.contactEmail }}" target="_top">
                                            {{ affordibilityMonthlyNetDepLimitErrorDetails?.contactEmail }}</a
                                        >
                                    </p>
                                }
                            </div>
                        </show-message>
                        <a
                            href="{{ affordibilityMonthlyNetDepLimitErrorDetails?.increaseLimitsUrl }}"
                            (click)="increaseLimits()"
                            target="_top"
                            type="button"
                            class="btn btn-primary w-100 mb-2">
                            {{ 'PARTY.CASHIER.web.deposit.affordibility.increase.limit' | translate }}
                        </a>
                    </div>
                }
                @case ('aml_limit_to_be_exceeded') {
                    <div>
                        <show-message id="affordibilityMonthly_aml_limit_to_be_exceeded" [type]="messageType.INFO">
                            <div info>
                                <strong>
                                    {{
                                        'PARTY.CASHIER.web.deposit.affordibility.limit.tobeexceeded.header2'
                                            | translate
                                                : {
                                                      netDepLimit: affordibilityMonthlyNetDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                  }
                                    }}
                                </strong>
                                <p>
                                    {{
                                        'PARTY.CASHIER.web.affordibility.limit.tobeexceeded.msg1'
                                            | translate
                                                : {
                                                      netDepLimit:
                                                          affordibilityMonthlyNetDepLimitErrorDetails?.allowedAmt?.value
                                                          | vnCurrency: affordibilityMonthlyNetDepLimitErrorDetails?.accountCurrency,
                                                  }
                                    }}
                                </p>
                                <p>
                                    <b
                                        ><a href="{{ affordibilityMonthlyNetDepLimitErrorDetails?.increaseLimitsUrl }}" target="_top">{{
                                            'PARTY.CASHIER.web.bonus.redirect.page' | translate
                                        }}</a></b
                                    >.
                                </p>
                            </div>
                        </show-message>
                    </div>
                }
            }
        </div>
    </div>
}
@if (affordibilityMonthlyGrossDepLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibilityMonthlyGrossDepLimitErrorDetails?.errorMessage) {
                @case ('AFFORDABILITY_LIMIT_GROSS_EXCEEDED') {
                    @if (isPlayerLevelOne) {
                        <div>
                            <show-message id="affordibilityMonthlyGross_aml_limit_exceeded" [type]="messageType.ERROR">
                                <div error>
                                    <strong
                                        (click)="monthlyLimit($event, 'deposit cap link')"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.177.deposit.affordibility.limit.exceeded.header'
                                                | translate
                                                    : {
                                                          netDepLimit:
                                                              affordibilityMonthlyGrossDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                          lossLimitsUrlError: affordibilityMonthlyGrossDepLimitErrorDetails?.lossLimitFaqLink,
                                                      }
                                        ">
                                    </strong>
                                    @if (isCountryUK) {
                                        <span>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.177.deposit.affordibility.limit.to.be.exceeded.msg1' | translate
                                                "></p>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.177.deposit.affordibility.limit.to.be.exceeded.msg7'
                                                        | translate: { contactEmail: affordibilityMonthlyGrossDepLimitErrorDetails?.contactEmail }
                                                "></p>
                                        </span>
                                    }
                                </div>
                            </show-message>
                        </div>
                    } @else {
                        <show-message id="affordibilityMonthlyGross_aml_limit_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong
                                    (click)="monthlyLimit($event, 'deposit cap link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.177.deposit.affordibility.limit.exceeded.header'
                                            | translate
                                                : {
                                                      netDepLimit:
                                                          affordibilityMonthlyGrossDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                      lossLimitsUrlError: affordibilityMonthlyGrossDepLimitErrorDetails?.lossLimitFaqLink,
                                                  }
                                    ">
                                </strong>
                                @if (isCountryUK) {
                                    <span>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.177.deposit.affordibility.limit.to.be.exceeded.msg1' | translate"></p>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg5' | translate"></p>
                                    </span>
                                }
                            </div>
                        </show-message>

                        @if (
                            ['AFFORDABILITY_LIMIT_GROSS_EXCEEDED', 'AFFORDABILITY_LIMIT_GROSS_TO_BE_EXCEEDED'].includes(
                                affordibilityMonthlyGrossDepLimitErrorDetails?.errorMessage
                            )
                        ) {
                            <div class="space-between mb-2">
                                <a
                                    (click)="checkMyLimits()"
                                    href="{{ affordibilityMonthlyGrossDepLimitErrorDetails?.increaseLimitsUrl }}"
                                    target="_top"
                                    type="button"
                                    class="btn btn-primary w-100 mb-2">
                                    {{ 'PARTY.CASHIER.web.deposit.affordibility.check.myLimits' | translate }}
                                </a>
                            </div>
                        }
                    }
                }
                @case ('AFFORDABILITY_LIMIT_GROSS_TO_BE_EXCEEDED') {
                    @if (isPlayerLevelOne) {
                        <div>
                            <show-message id="affordibilityMonthlyGross_aml_limit_to_be_exceeded" [type]="messageType.INFO">
                                <div info>
                                    <strong
                                        (click)="monthlyLimit($event, 'deposit cap link')"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.177.deposit.affordibility.limit.to.be.exceeded.header'
                                                | translate
                                                    : {
                                                          netDepLimit:
                                                              affordibilityMonthlyGrossDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                          lossLimitsUrlError: affordibilityMonthlyGrossDepLimitErrorDetails?.lossLimitFaqLink,
                                                      }
                                        ">
                                    </strong>
                                    @if (isCountryUK) {
                                        <span>
                                            <p class="line-space">
                                                {{
                                                    'PARTY.CASHIER.web.183.deposit.affordibility.limit.to.be.exceeded.msg5'
                                                        | translate
                                                            : {
                                                                  remainingamount:
                                                                      affordibilityMonthlyGrossDepLimitErrorDetails?.allowedAmt?.value
                                                                      | vnCurrency
                                                                          : affordibilityMonthlyGrossDepLimitErrorDetails?.allowedAmt?.currencyCode,
                                                              }
                                                }}
                                            </p>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.177.deposit.affordibility.limit.to.be.exceeded.msg1' | translate
                                                "></p>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.177.deposit.affordibility.limit.to.be.exceeded.msg7'
                                                        | translate: { contactEmail: affordibilityMonthlyGrossDepLimitErrorDetails?.contactEmail }
                                                "></p>
                                        </span>
                                    }
                                </div>
                            </show-message>
                        </div>
                    } @else {
                        <show-message id="affordibilityMonthlyGross_aml_limit_to_be_exceeded" [type]="messageType.INFO">
                            <div info>
                                <strong
                                    (click)="monthlyLimit($event, 'deposit cap link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.177.deposit.affordibility.limit.to.be.exceeded.header'
                                            | translate
                                                : {
                                                      netDepLimit:
                                                          affordibilityMonthlyGrossDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                      lossLimitsUrlError: affordibilityMonthlyGrossDepLimitErrorDetails?.lossLimitFaqLink,
                                                  }
                                    ">
                                </strong>
                                @if (isCountryUK) {
                                    <span>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.177.deposit.affordibility.limit.to.be.exceeded.msg1' | translate"></p>
                                        <p class="line-space">
                                            {{
                                                'PARTY.CASHIER.web.183.deposit.affordibility.limit.to.be.exceeded.msg5'
                                                    | translate
                                                        : {
                                                              remainingamount:
                                                                  affordibilityMonthlyGrossDepLimitErrorDetails?.allowedAmt?.value
                                                                  | vnCurrency
                                                                      : affordibilityMonthlyGrossDepLimitErrorDetails?.allowedAmt?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg5' | translate"></p>
                                    </span>
                                }
                            </div>
                        </show-message>

                        @if (
                            ['AFFORDABILITY_LIMIT_GROSS_EXCEEDED', 'AFFORDABILITY_LIMIT_GROSS_TO_BE_EXCEEDED'].includes(
                                affordibilityMonthlyGrossDepLimitErrorDetails?.errorMessage
                            )
                        ) {
                            <div class="space-between mb-2">
                                <a
                                    (click)="checkMyLimits()"
                                    href="{{ affordibilityMonthlyGrossDepLimitErrorDetails?.increaseLimitsUrl }}"
                                    target="_top"
                                    type="button"
                                    class="btn btn-primary w-100 mb-2">
                                    {{ 'PARTY.CASHIER.web.deposit.affordibility.check.myLimits' | translate }}
                                </a>
                            </div>
                        }
                    }
                }
            }
        </div>
    </div>
}
@if (affordibilityYearlyNetDepLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibilityYearlyNetDepLimitErrorDetails?.templateName) {
                @case ('aml_limit_exceeded') {
                    <div>
                        <show-message id="affordibilityYearly_aml_limit_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong> {{ 'PARTY.CASHIER.web.deposit.yearly.affordability.reached.header1' | translate }} </strong>
                                <p
                                    class="line-space"
                                    [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg1' | translate"></p>
                                <p
                                    class="line-space"
                                    [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg3' | translate"></p>
                            </div>
                        </show-message>
                    </div>
                }
                @case ('aml_limit_to_be_exceeded') {
                    <show-message id="affordibilityYearly_aml_limit_to_be_exceeded" [type]="messageType.INFO">
                        <div info>
                            <strong> {{ 'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.header1' | translate }} </strong>
                            <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg1' | translate"></p>
                            <p
                                class="line-space"
                                [vnDynamicHtml]="
                                    'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg2'
                                        | translate
                                            : {
                                                  limit:
                                                      affordibilityYearlyNetDepLimitErrorDetails?.allowedAmt?.value
                                                      | vnCurrency: affordibilityYearlyNetDepLimitErrorDetails?.accountCurrency,
                                              }
                                "></p>
                            <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg3' | translate"></p>
                        </div>
                    </show-message>
                }
            }
            <div class="space-between mb-2">
                <a
                    (click)="checkMyLimits()"
                    href="{{ affordibilityYearlyNetDepLimitErrorDetails?.increaseLimitsUrl }}"
                    target="_top"
                    type="button"
                    class="btn btn-primary fs-13 d-flex align-items-center">
                    {{ 'PARTY.CASHIER.web.deposit.affordibility.check.myLimits' | translate }}
                </a>
                <a
                    (click)="increaseLimits()"
                    href="{{ affordibilityYearlyNetDepLimitErrorDetails?.increaseLimitsUrl }}"
                    target="_top"
                    type="button"
                    class="btn btn-primary fs-13 d-flex align-items-center">
                    {{ 'PARTY.CASHIER.web.deposit.affordibility.increase.limit' | translate }}
                </a>
            </div>
        </div>
    </div>
}
@if (affordibilityYearlyGrossDepLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibilityYearlyGrossDepLimitErrorDetails?.errorMessage) {
                @case (
                    [
                        'AFFORDABILITY_LIMIT_GROSS_EXCEEDED',
                        'GROUPBASED_MONTHLY_LIMIT_GROSS_EXCEEDED',
                        'AFF_L5/6_GROSSLIMIT_A25_EXCEEDED',
                        'AFF_L5/6_GROSSLIMIT_U25_EXCEEDED',
                    ].includes(affordibilityYearlyGrossDepLimitErrorDetails?.errorMessage)
                        ? affordibilityYearlyGrossDepLimitErrorDetails?.errorMessage
                        : ''
                ) {
                    @if (isPlayerLevelOne) {
                        <div>
                            <show-message id="affordibilityMonthlyGross_aml_limit_exceeded" [type]="messageType.ERROR">
                                <div error>
                                    <strong
                                        (click)="monthlyLimit($event, 'deposit cap link')"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.177.deposit.affordibility.limit.exceeded.player1'
                                                | translate
                                                    : {
                                                          netDepLimit:
                                                              affordibilityYearlyGrossDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                          lossLimitsUrlError: affordibilityYearlyGrossDepLimitErrorDetails?.lossLimitFaqLink,
                                                      }
                                        ">
                                    </strong>
                                    @if (isCountryUK) {
                                        <span>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.deposit.affordibility.178.limit.tobeexceeded.msg1' | translate
                                                "></p>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.deposit.affordibility.annualized.limit.msg2'
                                                        | translate: { contactEmail: affordibilityYearlyGrossDepLimitErrorDetails?.contactEmail }
                                                "></p>
                                        </span>
                                    }
                                </div>
                            </show-message>
                        </div>
                    } @else {
                        <show-message id="affordibilityMonthlyGross_aml_limit_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong
                                    (click)="monthlyLimit($event, 'deposit cap link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.177.deposit.affordibility.limit.exceeded.player1'
                                            | translate
                                                : {
                                                      netDepLimit:
                                                          affordibilityYearlyGrossDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                      lossLimitsUrlError: affordibilityYearlyGrossDepLimitErrorDetails?.lossLimitFaqLink,
                                                  }
                                    ">
                                </strong>
                                @if (isCountryUK) {
                                    <span>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.affordibility.178.limit.tobeexceeded.msg1' | translate"></p>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.deposit.affordibility.annualized.limit.msg2'
                                                    | translate: { contactEmail: affordibilityYearlyGrossDepLimitErrorDetails?.contactEmail }
                                            "></p>
                                    </span>
                                }
                            </div>
                        </show-message>
                        <a
                            (click)="checkMyLimits()"
                            href="{{ affordibilityYearlyGrossDepLimitErrorDetails?.increaseLimitsUrl }}"
                            target="_top"
                            type="button"
                            class="btn btn-primary w-100">
                            {{ 'PARTY.CASHIER.web.deposit.affordibility.check.myLimits' | translate }}
                        </a>
                    }
                }
                @case (
                    [
                        'AFFORDABILITY_LIMIT_GROSS_TO_BE_EXCEEDED',
                        'GROUPBASED_MONTHLY_LIMIT_GROSS_TO_BE_EXCEEDED',
                        'AFF_L5/6_GROSSLIMIT_A25_TO_BE_EXCEEDED',
                        'AFF_L5/6_GROSSLIMIT_U25_TO_BE_EXCEEDED',
                    ].includes(affordibilityYearlyGrossDepLimitErrorDetails?.errorMessage)
                        ? affordibilityYearlyGrossDepLimitErrorDetails?.errorMessage
                        : ''
                ) {
                    @if (isPlayerLevelOne) {
                        <div>
                            <show-message id="affordibilityMonthlyGross_aml_limit_to_be_exceeded" [type]="messageType.INFO">
                                <div info>
                                    <strong
                                        (click)="monthlyLimit($event, 'deposit cap link')"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.deposit.affordibility.annualized.limit.tobeexceeded'
                                                | translate
                                                    : {
                                                          netDepLimit:
                                                              affordibilityYearlyGrossDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                          lossLimitsUrlError: affordibilityYearlyGrossDepLimitErrorDetails?.lossLimitFaqLink,
                                                      }
                                        ">
                                    </strong>
                                    @if (isCountryUK) {
                                        <span>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.deposit.affordibility.178.limit.tobeexceeded.msg1' | translate
                                                "></p>
                                            <p class="line-space">
                                                {{
                                                    'PARTY.CASHIER.web.178.deposit.affordibility.limit.to.be.exceeded.msg3'
                                                        | translate
                                                            : {
                                                                  remainingamount:
                                                                      affordibilityYearlyGrossDepLimitErrorDetails?.allowedAmt?.value
                                                                      | vnCurrency
                                                                          : affordibilityYearlyGrossDepLimitErrorDetails?.allowedAmt?.currencyCode,
                                                              }
                                                }}
                                            </p>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.deposit.affordibility.annualized.limit.msg2'
                                                        | translate: { contactEmail: affordibilityYearlyGrossDepLimitErrorDetails?.contactEmail }
                                                "></p>
                                        </span>
                                    }
                                </div>
                            </show-message>
                        </div>
                    } @else {
                        <show-message id="affordibilityMonthlyGross_aml_limit_to_be_exceeded" [type]="messageType.INFO">
                            <div info>
                                <strong
                                    (click)="monthlyLimit($event, 'deposit cap link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.deposit.affordibility.annualized.limit.tobeexceeded'
                                            | translate
                                                : {
                                                      netDepLimit:
                                                          affordibilityYearlyGrossDepLimitErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                      lossLimitsUrlError: affordibilityYearlyGrossDepLimitErrorDetails?.lossLimitFaqLink,
                                                  }
                                    ">
                                </strong>
                                @if (isCountryUK) {
                                    <span>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.178.deposit.affordibility.limit.msg1' | translate"></p>
                                        <p class="line-space">
                                            {{
                                                'PARTY.CASHIER.web.178.deposit.affordibility.limit.to.be.exceeded.msg3'
                                                    | translate
                                                        : {
                                                              remainingamount:
                                                                  affordibilityYearlyGrossDepLimitErrorDetails?.allowedAmt?.value
                                                                  | vnCurrency
                                                                      : affordibilityYearlyGrossDepLimitErrorDetails?.allowedAmt?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.deposit.affordibility.annualized.limit.msg2'
                                                    | translate: { contactEmail: affordibilityYearlyGrossDepLimitErrorDetails?.contactEmail }
                                            "></p>
                                    </span>
                                }
                            </div>
                        </show-message>
                    }
                }
            }
        </div>
    </div>
}
@if (affMaxLossLimitSuggestionErrorDetails && showMaxLossLimitMsg) {
    <show-message [type]="messageType.ERROR">
        <div error>
            <strong [vnDynamicHtml]="'PARTY.CASHIER.web.187.deposit.affordibility.limit.header' | translate"> </strong>
            <p
                class="line-space"
                (click)="lossLimitLink($event, 'max loss limit link')"
                [vnDynamicHtml]="
                    'PARTY.CASHIER.web.187.deposit.affordibility.limit.msg1'
                        | translate
                            : {
                                  url: affMaxLossLimitSuggestionErrorDetails?.faqLink,
                              }
                "></p>
        </div>
    </show-message>
    <div class="mb-2 space-between">
        <a (click)="maxLossLimitCTA('REJECT')" type="button" class="btn btn-primary fs-12 d-flex align-items-center">
            {{ 'PARTY.CASHIER.web.187.deposit.affordibility.limit.notNow' | translate }}
        </a>
        <a
            (click)="maxLossLimitCTA('ACCEPT')"
            href="{{ affMaxLossLimitSuggestionErrorDetails?.sgqLink }}"
            target="_top"
            type="button"
            class="btn btn-primary fs-12 d-flex align-items-center">
            {{ 'PARTY.CASHIER.web.187.deposit.affordibility.limit.setLimit' | translate }}
        </a>
    </div>
}
@if (affordibilityLtmGrossLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibilityLtmGrossLimitErrorDetails?.errorMessage) {
                @case ('DEPOSIT_12MONTHS_LIMIT_GROSS_EXCEEDED_BEA') {
                    <div>
                        <show-message id="deposit_12months_limit_gross_exceeded_bea" [type]="messageType.ERROR">
                            <div error>
                                <strong
                                    (click)="monthlyLimit($event, 'deposit cap link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.exceeded.header'
                                            | translate
                                                : {
                                                      limit: affordibilityLtmGrossLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      hardstopInfoLink: affordibilityLtmGrossLimitErrorDetails?.hardstopInfoLink,
                                                  }
                                    ">
                                </strong>
                                <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.hardstop.limit.text3' | translate }}</p>
                                <p
                                    class="line-space"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.exceeded.msg2'
                                            | translate
                                                : {
                                                      playerProtectionEmail: affordibilityLtmGrossLimitErrorDetails?.playerProtectionEmail,
                                                  }
                                    "></p>
                            </div>
                        </show-message>
                    </div>
                }
                @case ('DEPOSIT_12MONTHS_LIMIT_GROSS_TO_BE_EXCEEDED_BEA') {
                    <div>
                        <show-message id="deposit_12months_limit_gross_to_be_exceeded_bea" [type]="messageType.INFO">
                            <div info>
                                <strong
                                    (click)="monthlyLimit($event, 'deposit cap link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.to.be.exceeded.header'
                                            | translate
                                                : {
                                                      limit: affordibilityLtmGrossLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      hardstopInfoLink: affordibilityLtmGrossLimitErrorDetails?.hardstopInfoLink,
                                                  }
                                    ">
                                </strong>
                                <p class="line-space">
                                    {{
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.to.be.exceeded.msg4'
                                            | translate
                                                : {
                                                      remainingamount:
                                                          affordibilityLtmGrossLimitErrorDetails?.allowedAmt?.value
                                                          | vnCurrency: affordibilityLtmGrossLimitErrorDetails?.allowedAmt?.currencyCode,
                                                  }
                                    }}
                                </p>
                                <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.hardstop.limit.text3' | translate }}</p>
                                <p
                                    class="line-space"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.exceeded.msg2'
                                            | translate
                                                : {
                                                      playerProtectionEmail: affordibilityLtmGrossLimitErrorDetails?.playerProtectionEmail,
                                                  }
                                    "></p>
                            </div>
                        </show-message>
                    </div>
                }
                @case (
                    ['DEPOSIT_12MONTHS_LIMIT_GROSS_EXCEEDED', 'HARDSTOP_O80_GROSS_LIMIT_EXCEEDED'].includes(
                        affordibilityLtmGrossLimitErrorDetails?.errorMessage?.toUpperCase()
                    )
                        ? affordibilityLtmGrossLimitErrorDetails?.errorMessage?.toUpperCase()
                        : ''
                ) {
                    <div>
                        <show-message id="deposit_12months_limit_gross_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong
                                    (click)="monthlyLimit($event, 'deposit cap link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.exceeded.header2'
                                            | translate
                                                : {
                                                      limit: affordibilityLtmGrossLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      hardstopInfoLink: affordibilityLtmGrossLimitErrorDetails?.hardstopInfoLink,
                                                  }
                                    ">
                                </strong>
                                <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.hardstop.limit.text3' | translate }}</p>
                                <p
                                    (click)="contactUsLink($event, 'chat with us link')"
                                    class="line-space"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.deposit.hardstop.limit.text4'
                                            | translate
                                                : {
                                                      url: affordibilityLtmGrossLimitErrorDetails?.contactUs,
                                                  }
                                    "></p>
                            </div>
                        </show-message>
                    </div>
                }
                @case (
                    ['DEPOSIT_12MONTHS_LIMIT_GROSS_TO_BE_EXCEEDED', 'HARDSTOP_O80_GROSS_LIMIT_TO_BE_EXCEEDED'].includes(
                        affordibilityLtmGrossLimitErrorDetails?.errorMessage?.toUpperCase()
                    )
                        ? affordibilityLtmGrossLimitErrorDetails?.errorMessage?.toUpperCase()
                        : ''
                ) {
                    <div>
                        <show-message id="deposit_12months_limit_gross_to_be_exceeded" [type]="messageType.INFO">
                            <div info>
                                <strong
                                    (click)="monthlyLimit($event, 'deposit cap link')"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.to.be.exceeded.header1'
                                            | translate
                                                : {
                                                      limit: affordibilityLtmGrossLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      hardstopInfoLink: affordibilityLtmGrossLimitErrorDetails?.hardstopInfoLink,
                                                  }
                                    ">
                                </strong>
                                <p class="line-space">
                                    {{
                                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.to.be.exceeded.msg4'
                                            | translate
                                                : {
                                                      remainingamount:
                                                          affordibilityLtmGrossLimitErrorDetails?.allowedAmt?.value
                                                          | vnCurrency: affordibilityLtmGrossLimitErrorDetails?.allowedAmt?.currencyCode,
                                                  }
                                    }}
                                </p>
                                <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.hardstop.limit.text3' | translate }}</p>
                                <p
                                    (click)="contactUsLink($event, 'chat with us link')"
                                    class="line-space"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.deposit.hardstop.limit.text4'
                                            | translate
                                                : {
                                                      url: affordibilityLtmGrossLimitErrorDetails?.contactUs,
                                                  }
                                    "></p>
                            </div>
                        </show-message>
                    </div>
                }
            }
        </div>
    </div>
}

@if (affordibilityTUDepLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibilityTUDepLimitErrorDetails?.errorMessage) {
                @case ('TU_DEPOSIT_LIMIT_EXCEEDED') {
                    <show-message id="tu_deposit_limit_exceeded" [type]="messageType.ERROR">
                        <div error>
                            <strong>{{ 'PARTY.CASHIER.web.172.limit.to.be.reached.msg1' | translate }}</strong>
                            <p class="line-space">{{ 'PARTY.CASHIER.web.172.limit.to.be.reached.msg2' | translate }}</p>
                            <p class="line-space">
                                <span>{{ 'PARTY.CASHIER.web.172.limit.to.be.reached.msg4' | translate }}</span>
                                <span>{{ 'PARTY.CASHIER.web.172.limit.reached.msg2' | translate }}</span>
                            </p>
                        </div>
                    </show-message>
                }
                @case ('TU_DEPOSIT_LIMIT_TO_BE_EXCEEDED') {
                    <show-message id="tu_deposit_limit_to_be_exceeded" [type]="messageType.INFO">
                        <div info>
                            <strong>{{ 'PARTY.CASHIER.web.172.limit.to.be.reached.msg1' | translate }}</strong>
                            <p class="line-space">
                                <span>{{ 'PARTY.CASHIER.web.172.limit.to.be.reached.msg2' | translate }}</span>
                                <span>{{ 'PARTY.CASHIER.web.172.limit.to.be.reached.msg4' | translate }}</span>
                            </p>
                            <p class="line-space">
                                {{
                                    'PARTY.CASHIER.web.172.limit.to.be.reached.msg3'
                                        | translate
                                            : {
                                                  remainingamount:
                                                      affordibilityTUDepLimitErrorDetails?.allowedAmt?.value
                                                      | vnCurrency: affordibilityTUDepLimitErrorDetails?.allowedAmt?.currencyCode,
                                              }
                                }}
                            </p>
                        </div>
                    </show-message>
                }
            }
        </div>
    </div>
}

@if (affordibilityHardStopLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibilityHardStopLimitErrorDetails?.errorMessage) {
                @case ('HARDSTOP_MONTHLY_LIMIT_EXCEEDED') {
                    <show-message id="hardstop_monthly_limit_exceeded" [type]="messageType.ERROR">
                        <div error>
                            @if (affordibilityHardStopLimitErrorDetails?.errorCode == 174) {
                                <div class="message-text">
                                    <strong
                                        (click)="monthlyLimit($event, 'monthly limit link')"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.hardstoplimit.174.limit.reached.msg1'
                                                | translate
                                                    : {
                                                          url: affordibilityHardStopLimitErrorDetails?.hardstopInfoLink,
                                                          amount: affordibilityHardStopLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      }
                                        ">
                                    </strong>
                                    <p
                                        class="line-space"
                                        (click)="contactUsLink($event, 'contact us link')"
                                        id="hardstop_monthly_limit_other"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.hardstoplimit.174.limit.to.be.reached.other.qd.msg'
                                                | translate
                                                    : {
                                                          url: affordibilityHardStopLimitErrorDetails?.contactUs,
                                                      }
                                        "></p>
                                </div>
                            }
                            @if (affordibilityHardStopLimitErrorDetails?.errorCode == 173) {
                                <div class="message-text">
                                    <strong
                                        (click)="monthlyLimit($event, 'first 30-day limit link')"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.hardstoplimit.173.limit.reached.msg1'
                                                | translate
                                                    : {
                                                          url: affordibilityHardStopLimitErrorDetails?.hardstopInfoLink,
                                                          amount: affordibilityHardStopLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                      }
                                        ">
                                    </strong>
                                    <p class="line-space">{{ 'PARTY.CASHIER.web.hardstoplimit.173.limit.reached.msg2' | translate }}</p>
                                    <p
                                        class="line-space"
                                        (click)="contactUsLink($event, 'contact us link')"
                                        id="hardstop_monthly_limit_other"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.contact.us.msg1'
                                                | translate
                                                    : {
                                                          url: affordibilityHardStopLimitErrorDetails?.contactUs,
                                                      }
                                        "></p>
                                </div>
                            }
                        </div>
                    </show-message>
                }
                @case ('HARDSTOP_MONTHLY_LIMIT_TO_BE_EXCEEDED') {
                    <show-message id="hardstop_monthly_limit_to_be_exceeded" [type]="messageType.INFO">
                        <div info>
                            @if (affordibilityHardStopLimitErrorDetails?.errorCode == 174) {
                                <div>
                                    <p (click)="monthlyLimit($event, 'monthly limit link')" id="hardstop_monthly_to_be_exceed">
                                        <strong
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.hardstoplimit.174.limit.to.be.reached.msg1'
                                                    | translate
                                                        : {
                                                              url: affordibilityHardStopLimitErrorDetails?.hardstopInfoLink,
                                                              amount: affordibilityHardStopLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                          }
                                            ">
                                        </strong
                                        ><br />
                                    </p>
                                    <p class="line-space">
                                        {{
                                            'PARTY.CASHIER.web.hardstoplimit.174.limit.to.be.reached.msg2'
                                                | translate
                                                    : {
                                                          remainingamount:
                                                              affordibilityHardStopLimitErrorDetails?.allowedAmt?.value
                                                              | vnCurrency: affordibilityHardStopLimitErrorDetails?.allowedAmt?.currencyCode,
                                                      }
                                        }}
                                    </p>
                                    <p
                                        class="line-space"
                                        (click)="contactUsLink($event, 'contact us link')"
                                        id="hardstop_monthly_to_be_exceed_other"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.hardstoplimit.174.limit.to.be.reached.other.qd.msg'
                                                | translate
                                                    : {
                                                          url: affordibilityHardStopLimitErrorDetails?.contactUs,
                                                      }
                                        "></p>
                                </div>
                            }
                            @if (affordibilityHardStopLimitErrorDetails?.errorCode == 173) {
                                <div class="message-text">
                                    <p (click)="monthlyLimit($event, 'first 30-day limit link')" id="affordabilityMonthlyHardstopLimit">
                                        <strong
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.hardstoplimit.173.limit.to.be.reached.msg1'
                                                    | translate
                                                        : {
                                                              url: affordibilityHardStopLimitErrorDetails?.hardstopInfoLink,
                                                              amount: affordibilityHardStopLimitErrorDetails?.limit | vnCurrency: currencyGBP,
                                                          }
                                            ">
                                        </strong>
                                    </p>
                                    <p class="line-space">
                                        {{
                                            'PARTY.CASHIER.web.hardstoplimit.174.limit.to.be.reached.msg2'
                                                | translate
                                                    : {
                                                          remainingamount:
                                                              affordibilityHardStopLimitErrorDetails?.allowedAmt?.value
                                                              | vnCurrency: affordibilityHardStopLimitErrorDetails?.allowedAmt?.currencyCode,
                                                      }
                                        }}
                                    </p>
                                    <p>{{ 'PARTY.CASHIER.web.hardstoplimit.173.limit.reached.msg2' | translate }}</p>
                                    <p
                                        (click)="contactUsLink($event, 'contact us link')"
                                        id="affordabilityMonthlyHardstopLimitContactUs"
                                        class="line-space"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.contact.us.msg1'
                                                | translate
                                                    : {
                                                          url: affordibilityHardStopLimitErrorDetails?.contactUs,
                                                      }
                                        "></p>
                                </div>
                            }
                        </div>
                    </show-message>
                }
            }
        </div>
    </div>
}

@if (affordibility3kMilestoneLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibility3kMilestoneLimitErrorDetails?.errorMessage) {
                @case ('MILESTONE_SGQ_LIMIT_EXCEEDED') {
                    <show-message id="affordibility3k_limitExceed" [type]="messageType.ERROR">
                        <div error>
                            <p>
                                <strong>{{ 'PARTY.CASHIER.web.175.3k.milestone.limit.reached.msg1' | translate }}</strong>
                            </p>
                            <p [vnDynamicHtml]="'PARTY.CASHIER.web.175.3k.milestone.limit.reached.msg2' | translate"></p>
                            <p>{{ 'PARTY.CASHIER.web.175.3k.milestone.limit.reached.msg3' | translate }}</p>
                        </div>
                    </show-message>
                }
                @case ('MILESTONE_SGQ_LIMIT_TO_BE_EXCEEDED') {
                    <show-message id="affordibility3k_limittobeExceed" [type]="messageType.INFO">
                        <div info>
                            <p>
                                <strong> {{ 'PARTY.CASHIER.web.175.3k.milestone.limit.reached.msg1' | translate }}</strong>
                            </p>
                            <p>
                                {{
                                    'PARTY.CASHIER.web.175.3k.milestone.limit.to.be.reached.msg1'
                                        | translate
                                            : {
                                                  remainingamount:
                                                      affordibility3kMilestoneLimitErrorDetails?.allowedAmt?.value
                                                      | vnCurrency: affordibility3kMilestoneLimitErrorDetails?.allowedAmt?.currencyCode,
                                              }
                                }}
                            </p>
                            <p [vnDynamicHtml]="'PARTY.CASHIER.web.affordibility.175.3k.milestone.limit.to.be.reached.msg2' | translate"></p>
                            <p>{{ 'PARTY.CASHIER.web.175.3k.milestone.limit.reached.msg3' | translate }}</p>
                        </div>
                    </show-message>
                }
            }
        </div>
        <a
            href="{{ affordibility3kMilestoneLimitErrorDetails?.sgqLink }}"
            target="_top"
            type="button"
            class="btn btn-primary w-100 mb-2"
            (click)="startButtonClick()"
            id="3kmilestonereached">
            {{ 'PARTY.CASHIER.web.175.3k.milestone.limit.reached.msg4' | translate }}
        </a>
    </div>
}

@if (affordibility8kMilestoneLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibility8kMilestoneLimitErrorDetails?.errorMessage) {
                @case ('MILESTONE_SELF_CERT_LIMIT_EXCEEDED') {
                    <show-message id="affordibility8k_limitExceed" [type]="messageType.ERROR">
                        <div error>
                            <p>
                                <strong> {{ 'PARTY.CASHIER.web.180.limit.tobereached.msg3' | translate }} </strong><br />
                            </p>
                            <p class="line-space">{{ 'PARTY.CASHIER.web.180.tobereached.msg6' | translate }}</p>
                            @if (hideChat) {
                                <p
                                    class="line-space"
                                    (click)="contactUsLink($event, 'contact us link')"
                                    id="8kmilestonereached"
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.contact.us.msg1'
                                            | translate
                                                : {
                                                      url: affordibility8kMilestoneLimitErrorDetails?.contactUs,
                                                  }
                                    "></p>
                            }
                        </div>
                    </show-message>
                }
                @case ('MILESTONE_SELF_CERT_LIMIT_TO_BE_EXCEEDED') {
                    <show-message id="affordibility8k_limittobeExceed" [type]="messageType.INFO">
                        <div info>
                            <p>
                                {{
                                    'PARTY.CASHIER.web.176.8k.milestone.to.be.limit.reached.msg2'
                                        | translate
                                            : {
                                                  remainingamount:
                                                      affordibility8kMilestoneLimitErrorDetails?.allowedAmt?.value
                                                      | vnCurrency: affordibility8kMilestoneLimitErrorDetails?.allowedAmt?.currencyCode,
                                              }
                                }}
                            </p>
                            <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.180.limit.tobereached.msg5' | translate"></p>
                            <p
                                class="line-space"
                                [vnDynamicHtml]="'PARTY.CASHIER.web.180.deposit.affordibility.limit.to.be.exceeded.msg5' | translate"></p>
                        </div>
                    </show-message>
                }
            }
        </div>
        @if (affordibility8kMilestoneLimitErrorDetails?.errorMessage == 'MILESTONE_SELF_CERT_LIMIT_EXCEEDED') {
            <div>
                <div class="space-between mb-2">
                    @if (!hideChat) {
                        <button (click)="triggerChat('live chat cta')" id="triggerChat" target="_top" type="button" class="btn btn-chat fs-13">
                            {{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.liveChat' | translate }}
                        </button>
                        <a
                            href="{{ affordibility8kMilestoneLimitErrorDetails?.selfCertLink }}"
                            target="_top"
                            type="button"
                            class="btn btn-primary fs-13 d-flex align-items-center"
                            (click)="startQuestionnaire()"
                            id="startQuestionnaire">
                            {{ 'PARTY.CASHIER.web.176.8k.milestone.to.be.limit.reached.msg5' | translate }}
                        </a>
                    }
                    @if (hideChat) {
                        <a
                            href="{{ affordibility8kMilestoneLimitErrorDetails?.selfCertLink }}"
                            target="_top"
                            type="button"
                            class="btn btn-primary w-100"
                            (click)="startQuestionnaire()"
                            id="startQuestionnaire">
                            {{ 'PARTY.CASHIER.web.176.8k.milestone.to.be.limit.reached.msg5' | translate }}
                        </a>
                    }
                </div>
            </div>
        }
        @if (affordibility8kMilestoneLimitErrorDetails?.errorMessage == 'MILESTONE_SELF_CERT_LIMIT_TO_BE_EXCEEDED') {
            <div>
                <a
                    href="{{ affordibility8kMilestoneLimitErrorDetails?.selfCertLink }}"
                    target="_top"
                    type="button"
                    class="btn btn-primary w-100 mb-2"
                    (click)="startQuestionnaire()"
                    id="selfcertlink">
                    {{ 'PARTY.CASHIER.web.176.8k.milestone.to.be.limit.reached.msg5' | translate }}
                </a>
            </div>
        }
    </div>
}

@if (affordibilityMilestoneSgqGrossLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibilityMilestoneSgqGrossLimitErrorDetails?.errorMessage) {
                @case ('MILESTONE_SGQ_LIMIT_GROSS_EXCEEDED') {
                    <div>
                        <show-message id="affordibility_milestone_sgq_limit_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong> {{ 'PARTY.CASHIER.web.179.deposit.affordibility.limit.exceeded.header' | translate }} </strong>
                                @if (isCountryUK) {
                                    <span>
                                        <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.179.milestone.limit.exceeded.msg2' | translate"></p>
                                        <p class="line-space">{{ 'PARTY.CASHIER.web.179.milestone.limit.exceeded.msg3' | translate }}</p>
                                    </span>
                                }
                            </div>
                        </show-message>
                    </div>
                }
                @case ('MILESTONE_SGQ_LIMIT_GROSS_TO_BE_EXCEEDED') {
                    <div>
                        <show-message id="affordibility_milestone_sgq_limit_to_be_exceeded" [type]="messageType.INFO">
                            <div info>
                                <strong> {{ 'PARTY.CASHIER.web.179.milestone.limit.to.be.exceeded.header' | translate }} </strong>
                                @if (isCountryUK) {
                                    <span>
                                        <p class="line-space">
                                            {{
                                                'PARTY.CASHIER.web.179.milestone.limit.to.be.exceeded.msg1'
                                                    | translate
                                                        : {
                                                              remainingamount:
                                                                  affordibilityMilestoneSgqGrossLimitErrorDetails?.allowedAmt?.value
                                                                  | vnCurrency
                                                                      : affordibilityMilestoneSgqGrossLimitErrorDetails?.allowedAmt?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.179.milestone.limit.to.be.exceeded.msg2' | translate"></p>
                                        <p class="line-space">{{ 'PARTY.CASHIER.web.179.milestone.limit.to.be.exceeded.msg3' | translate }}</p>
                                    </span>
                                }
                            </div>
                        </show-message>
                    </div>
                }
            }
            @if (
                ['MILESTONE_SGQ_LIMIT_GROSS_EXCEEDED', 'MILESTONE_SGQ_LIMIT_GROSS_TO_BE_EXCEEDED'].includes(
                    affordibilityMilestoneSgqGrossLimitErrorDetails?.errorMessage
                )
            ) {
                <a type="button" class="btn btn-primary w-100 mb-2" (click)="startButtonClick()" id="sgqmilestonetobeexceeded">
                    {{ 'PARTY.CASHIER.web.179.milestone.limit.start.btn.txt' | translate }}
                </a>
            }
        </div>
    </div>
}

@if (affordibilityMilestoneSelfCertGrossLimitErrorDetails) {
    <div>
        <div>
            @switch (affordibilityMilestoneSelfCertGrossLimitErrorDetails?.errorMessage) {
                @case ('MILESTONE_SELF_CERT_LIMIT_GROSS_EXCEEDED') {
                    <div>
                        <show-message id="affordibility_milestone_self_cert_limit_exceeded" [type]="messageType.ERROR">
                            <div error>
                                <strong> {{ 'PARTY.CASHIER.web.180.limit.tobereached.msg3' | translate }} </strong>
                                @if (isCountryUK) {
                                    <span>
                                        <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.180.tobereached.msg6' | translate"></p>
                                        @if (hideChat) {
                                            <p
                                                (click)="contactUsLink($event, 'contact us link')"
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.contact.us.msg1'
                                                        | translate
                                                            : {
                                                                  url: affordibilityMilestoneSelfCertGrossLimitErrorDetails?.contactUs,
                                                              }
                                                "></p>
                                        }
                                    </span>
                                }
                            </div>
                        </show-message>
                    </div>
                }
                @case ('MILESTONE_SELF_CERT_LIMIT_GROSS_TO_BE_EXCEEDED') {
                    <div>
                        <show-message id="affordibility_milestone_self_cert_limit_to_be_exceeded" [type]="messageType.INFO">
                            <div info>
                                @if (isCountryUK) {
                                    <span>
                                        <p>
                                            {{
                                                'PARTY.CASHIER.web.180.deposit.affordibility.limit.to.be.exceeded.msg4'
                                                    | translate
                                                        : {
                                                              remainingamount:
                                                                  affordibilityMilestoneSelfCertGrossLimitErrorDetails?.allowedAmt?.value
                                                                  | vnCurrency
                                                                      : affordibilityMilestoneSelfCertGrossLimitErrorDetails?.allowedAmt
                                                                            ?.currencyCode,
                                                          }
                                            }}
                                        </p>
                                        <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.180.limit.tobereached.msg5' | translate"></p>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.180.deposit.affordibility.limit.to.be.exceeded.msg5' | translate"></p>
                                    </span>
                                }
                            </div>
                        </show-message>
                    </div>
                }
            }
        </div>
        @if (affordibilityMilestoneSelfCertGrossLimitErrorDetails?.errorMessage == 'MILESTONE_SELF_CERT_LIMIT_GROSS_EXCEEDED') {
            @if (hideChat) {
                <a type="button" class="btn btn-primary w-100 mb-2" (click)="startQuestionnaire()" id="selfcertmilestonetobeexceeded">
                    {{ 'PARTY.CASHIER.web.180.deposit.affordibility.start.questionnaire.btn.txt' | translate }}
                </a>
            }
            @if (!hideChat) {
                <div class="space-between mb-2">
                    <button (click)="triggerChat('live chat cta')" id="triggerChat" target="_top" type="button" class="btn btn-chat fs-13">
                        {{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.liveChat' | translate }}
                    </button>
                    <a
                        target="_top"
                        type="button"
                        class="btn btn-primary fs-13 d-flex align-items-center"
                        (click)="startQuestionnaire()"
                        id="selfcertmilestonetobeexceeded">
                        {{ 'PARTY.CASHIER.web.180.deposit.affordibility.start.questionnaire.btn.txt' | translate }}
                    </a>
                </div>
            }
        }
        @if (affordibilityMilestoneSelfCertGrossLimitErrorDetails?.errorMessage == 'MILESTONE_SELF_CERT_LIMIT_GROSS_TO_BE_EXCEEDED') {
            <a target="_top" type="button" class="btn btn-primary w-100 mb-2" (click)="startQuestionnaire()" id="selfcertmilestonetobeexceeded">
                {{ 'PARTY.CASHIER.web.180.deposit.affordibility.start.questionnaire.btn.txt' | translate }}
            </a>
        }
    </div>
}
@if (svocAffordabilityErrorDetails) {
    <div>
        <div>
            @switch (svocAffordabilityErrorDetails?.errorCode) {
                @case ('161') {
                    <div id="hardStopchatUrl">
                        <div>
                            @switch (svocAffordabilityErrorDetails?.errorMessage) {
                                @case ('AML_LIMIT_EXCEEDED') {
                                    <show-message id="svocAffordability_limitExceed" [type]="messageType.ERROR">
                                        <div error>
                                            <strong
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.svoc.161.header2'
                                                        | translate
                                                            : {
                                                                  hardstopInfoLink: svocAffordabilityErrorDetails?.hardstopInfoLink,
                                                              }
                                                ">
                                            </strong>
                                            <div>
                                                @if (!isCountryUK) {
                                                    <p>
                                                        {{
                                                            'PARTY.CASHIER.web.svoc.161.message1'
                                                                | translate
                                                                    : {
                                                                          phoneNumber: svocAffordabilityErrorDetails?.contactUsPhone,
                                                                      }
                                                        }}
                                                    </p>
                                                }
                                                @if (isCountryUK) {
                                                    <span>
                                                        {{
                                                            'PARTY.CASHIER.web.svoc.161.message4.uk'
                                                                | translate
                                                                    : {
                                                                          phoneNumber: svocAffordabilityErrorDetails?.contactUsPhone,
                                                                      }
                                                        }}
                                                    </span>
                                                }
                                                <span>{{ 'PARTY.CASHIER.web.svoc.chat.text1' | translate }}</span>
                                                <span>{{ 'PARTY.CASHIER.web.svoc.161.message3' | translate }} </span>
                                                <a href="mailto:{{ svocAffordabilityErrorDetails?.contactEmail }}" target="_top">{{
                                                    svocAffordabilityErrorDetails?.contactEmail
                                                }}</a
                                                >.
                                            </div>
                                        </div>
                                    </show-message>
                                }
                                @case ('AML_LIMIT_TO_BE_EXCEEDED') {
                                    <show-message id="svocAffordability_limitTobeExceed" [type]="messageType.INFO">
                                        <div info>
                                            <strong
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.svoc.161.header3'
                                                        | translate
                                                            : {
                                                                  hardstopInfoLink: svocAffordabilityErrorDetails?.hardstopInfoLink,
                                                              }
                                                ">
                                            </strong>
                                            <div>
                                                @if (!isCountryUK) {
                                                    <p>
                                                        {{
                                                            'PARTY.CASHIER.web.svoc.161.message1'
                                                                | translate
                                                                    : {
                                                                          phoneNumber: svocAffordabilityErrorDetails?.contactUsPhone,
                                                                      }
                                                        }}
                                                    </p>
                                                }
                                                @if (isCountryUK) {
                                                    <span>
                                                        {{
                                                            'PARTY.CASHIER.web.svoc.161.message4.uk'
                                                                | translate
                                                                    : {
                                                                          phoneNumber: svocAffordabilityErrorDetails?.contactUsPhone,
                                                                      }
                                                        }}
                                                    </span>
                                                }
                                                <span
                                                    (click)="triggerChat('chat link')"
                                                    id="svoc161triggerchatexceed"
                                                    class="text-bold cursor-pointer txt-underlined"
                                                    >{{ 'PARTY.CASHIER.web.svoc.chat.text1' | translate }}</span
                                                >
                                                <span>{{ 'PARTY.CASHIER.web.svoc.161.message3' | translate }} </span>
                                                <a href="mailto:{{ svocAffordabilityErrorDetails?.contactEmail }}" target="_top">{{
                                                    svocAffordabilityErrorDetails?.contactEmail
                                                }}</a
                                                >.
                                            </div>
                                        </div>
                                    </show-message>
                                }
                            }
                        </div>
                    </div>
                }
                @case ('160') {
                    <div id="hardStopchatUrl">
                        <div>
                            @switch (svocAffordabilityErrorDetails?.errorMessage) {
                                @case ('AML_LIMIT_EXCEEDED') {
                                    <show-message id="svocAffordability_limitExceed160" [type]="messageType.ERROR">
                                        <div error>
                                            <strong
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.svoc.160.header1'
                                                        | translate
                                                            : {
                                                                  hardstopInfoLink: svocAffordabilityErrorDetails?.hardstopInfoLink,
                                                              }
                                                ">
                                            </strong>
                                            @if (!isCountryUK) {
                                                <p>{{ 'PARTY.CASHIER.web.svoc.160.message1' | translate }}</p>
                                            }
                                            @if (isCountryUK) {
                                                <div>
                                                    <p>
                                                        <span>
                                                            {{
                                                                'PARTY.CASHIER.web.svoc.161.message5.uk'
                                                                    | translate
                                                                        : {
                                                                              phoneNumber: svocAffordabilityErrorDetails?.contactUsPhone,
                                                                          }
                                                            }}
                                                        </span>
                                                        <span>{{ 'PARTY.CASHIER.web.svoc.chat.text1' | translate }}.</span>
                                                    </p>
                                                    <p class="mt-1">
                                                        {{
                                                            'PARTY.CASHIER.web.svoc.160.message1.uk'
                                                                | translate
                                                                    : {
                                                                          restrictionValueInGBPCurrency:
                                                                              svocAffordabilityErrorDetails?.netDepLimit
                                                                              | vnCurrency: svocAffordabilityErrorDetails?.accountCurrency,
                                                                      }
                                                        }}
                                                    </p>
                                                </div>
                                            }
                                        </div>
                                    </show-message>
                                }
                                @case ('AML_LIMIT_TO_BE_EXCEEDED') {
                                    <show-message id="svocAffordability_limitTobeExceed160" [type]="messageType.INFO">
                                        <div info>
                                            @if (!isCountryUK) {
                                                <strong>{{
                                                    'PARTY.CASHIER.web.svoc.160.header3'
                                                        | translate
                                                            : {
                                                                  netDepLimit: svocAffordabilityErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                              }
                                                }}</strong>
                                            }
                                            @if (isCountryUK) {
                                                <strong
                                                    [vnDynamicHtml]="
                                                        'PARTY.CASHIER.web.svoc.160.header3.uk'
                                                            | translate
                                                                : {
                                                                      hardstopInfoLink: svocAffordabilityErrorDetails?.hardstopInfoLink,
                                                                  }
                                                    ">
                                                </strong>
                                            }
                                            <div>
                                                <span>
                                                    {{
                                                        'PARTY.CASHIER.web.svoc.161.message4.uk'
                                                            | translate
                                                                : {
                                                                      phoneNumber: svocAffordabilityErrorDetails?.contactUsPhone,
                                                                  }
                                                    }}
                                                </span>
                                                <span
                                                    (click)="triggerChat('chat link')"
                                                    id="svoc161triggerchatexceed"
                                                    class="text-bold cursor-pointer txt-underlined"
                                                    >{{ 'PARTY.CASHIER.web.svoc.chat.text1' | translate }}</span
                                                >
                                                <span>{{ 'PARTY.CASHIER.web.svoc.161.message3' | translate }} </span>
                                                <a href="mailto:{{ svocAffordabilityErrorDetails?.contactEmail }}" target="_top">{{
                                                    svocAffordabilityErrorDetails?.contactEmail
                                                }}</a
                                                >.
                                            </div>
                                        </div>
                                    </show-message>
                                }
                            }
                        </div>
                    </div>
                }
                @case ('167') {
                    <div>
                        <div>
                            @switch (svocAffordabilityErrorDetails?.errorMessage) {
                                @case ('AFFORDABILITY_LIMIT_EXCEEDED') {
                                    <div>
                                        <show-message id="svocAffordability_limitExceed167" [type]="messageType.ERROR">
                                            <div error>
                                                <strong
                                                    (click)="monthlyLimit($event, 'loss limit link')"
                                                    [vnDynamicHtml]="
                                                        'PARTY.CASHIER.web.deposit.yearly.affordibility.tobeexceeded.header3'
                                                            | translate
                                                                : {
                                                                      amount: svocAffordabilityErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                                      url: svocAffordabilityErrorDetails?.lossLimitFaqLink,
                                                                  }
                                                    "></strong>
                                                <p
                                                    class="line-space"
                                                    [vnDynamicHtml]="
                                                        'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg4' | translate
                                                    "></p>
                                                <p
                                                    class="line-space"
                                                    [vnDynamicHtml]="
                                                        'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg5' | translate
                                                    "></p>
                                            </div>
                                        </show-message>
                                    </div>
                                }
                                @case ('AFFORDABILITY_LIMIT_TO_BE_EXCEEDED') {
                                    <show-message id="svocAffordability_limitTobeExceed167" [type]="messageType.INFO">
                                        <div info>
                                            <strong
                                                (click)="monthlyLimit($event, 'loss limit link')"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.deposit.yearly.affordibility.tobeexceeded.header2'
                                                        | translate
                                                            : {
                                                                  amount: svocAffordabilityErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                                                  url: svocAffordabilityErrorDetails?.lossLimitFaqLink,
                                                              }
                                                "></strong>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg4' | translate"></p>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.183.deposit.affordibility.limit.to.be.exceeded.msg5'
                                                        | translate
                                                            : {
                                                                  remainingamount:
                                                                      svocAffordabilityErrorDetails?.allowedAmt?.value
                                                                      | vnCurrency: svocAffordabilityErrorDetails?.allowedAmt?.currencyCode,
                                                              }
                                                "></p>
                                            <p
                                                class="line-space"
                                                [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg5' | translate"></p>
                                        </div>
                                    </show-message>
                                }
                            }
                        </div>
                        <div class="mb-2 space-between">
                            <a
                                (click)="checkMyLimits()"
                                href="{{ svocAffordabilityErrorDetails?.increaseLimitsUrl }}"
                                target="_top"
                                type="button"
                                class="btn btn-primary w-100 align-items-center">
                                {{ 'PARTY.CASHIER.web.deposit.affordibility.check.myLimits' | translate }}
                            </a>
                        </div>
                    </div>
                }
            }
        </div>
        @if (showChatCTA && !showChatNotAvailable && !hideChat) {
            <div>
                <button
                    (click)="triggerChat('chat here cta')"
                    id="svocaffordabilityerrorchat"
                    type="button"
                    class="btn btn-light btn-lg theme-chat w-100 mb-2">
                    {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                </button>
            </div>
        }
        @if (showChatNotAvailable) {
            <div>
                <div>
                    <a href="javascript:void(0)" class="btn btn-chat btn-lg theme-chat w-100 mb-2">
                        {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                    </a>
                    <div class="zendesk-live-block">{{ 'PARTY.CASHIER.web.deposit.chat.zendesk.text' | translate }}</div>
                </div>
            </div>
        }
    </div>
}
@if (['166', '182'].includes(svocAffordabilityErrorDetails?.errorCode)) {
    <div>
        @if (!isPlayerLevelOne) {
            @if (
                ['AFFORDABILITY_LIMIT_EXCEEDED', 'GROUPBASED_MONTHLY_LIMIT_EXCEEDED'].includes(
                    svocAffordabilityErrorDetails?.errorMessage?.toUpperCase()
                )
            ) {
                <show-message id="svocAffordability_limitExceed166" [type]="messageType.ERROR">
                    <div error>
                        <strong
                            (click)="monthlyLimit($event, 'loss limit link')"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.svoc.166.level2.header4'
                                    | translate
                                        : {
                                              amount: svocAffordabilityErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                              url: svocAffordabilityErrorDetails?.lossLimitFaqLink,
                                          }
                            "></strong>
                        <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.svoc.166.level2.msg1' | translate"></p>
                        <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg5' | translate"></p>
                    </div>
                </show-message>
            }
            @if (
                ['AFFORDABILITY_LIMIT_TO_BE_EXCEEDED', 'GROUPBASED_MONTHLY_LIMIT_TO_BE_EXCEEDED'].includes(
                    svocAffordabilityErrorDetails?.errorMessage?.toUpperCase()
                )
            ) {
                <show-message id="svocAffordability_limitTobeExceed166" [type]="messageType.INFO">
                    <div info>
                        <strong
                            (click)="monthlyLimit($event, 'loss limit link')"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.svoc.166.level2.header3'
                                    | translate
                                        : {
                                              amount: svocAffordabilityErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                              url: svocAffordabilityErrorDetails?.lossLimitFaqLink,
                                          }
                            "></strong>
                        <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.svoc.166.level2.msg1' | translate"></p>
                        <p
                            class="line-space"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.183.deposit.affordibility.limit.to.be.exceeded.msg5'
                                    | translate
                                        : {
                                              remainingamount:
                                                  svocAffordabilityErrorDetails?.allowedAmt?.value
                                                  | vnCurrency: svocAffordabilityErrorDetails?.allowedAmt?.currencyCode,
                                          }
                            "></p>
                        <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.yearly.affordability.tobeReached.msg5' | translate"></p>
                    </div>
                </show-message>
            }
            <div class="mb-2 space-between">
                <a
                    (click)="checkMyLimits()"
                    href="{{ svocAffordabilityErrorDetails?.increaseLimitsUrl }}"
                    target="_top"
                    type="button"
                    class="btn btn-primary w-100 align-items-center">
                    {{ 'PARTY.CASHIER.web.deposit.affordibility.check.myLimits' | translate }}
                </a>
            </div>
        }
        @if (isPlayerLevelOne) {
            @if (
                ['AFFORDABILITY_LIMIT_EXCEEDED', 'GROUPBASED_MONTHLY_LIMIT_EXCEEDED'].includes(
                    svocAffordabilityErrorDetails?.errorMessage?.toUpperCase()
                )
            ) {
                <show-message id="svocAffordability_limitExceedisPlayerLevelOne" [type]="messageType.ERROR">
                    <div error>
                        <strong
                            (click)="monthlyLimit($event, 'loss limit link')"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.svoc.166.level2.header4'
                                    | translate
                                        : {
                                              amount: svocAffordabilityErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                              url: svocAffordabilityErrorDetails?.lossLimitFaqLink,
                                          }
                            "></strong>
                        <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.svoc.166.level1.msg1' | translate"></p>
                        <p
                            class="line-space"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.deposit.affordibility.annualized.limit.msg2'
                                    | translate: { contactEmail: svocAffordabilityErrorDetails?.contactEmail }
                            "></p>
                    </div>
                </show-message>
            }
            @if (
                ['AFFORDABILITY_LIMIT_TO_BE_EXCEEDED', 'GROUPBASED_MONTHLY_LIMIT_TO_BE_EXCEEDED'].includes(
                    svocAffordabilityErrorDetails?.errorMessage?.toUpperCase()
                )
            ) {
                <show-message id="svocAffordability_limitTobeExceedisPlayerLevelOne" [type]="messageType.INFO">
                    <div info>
                        <strong
                            (click)="monthlyLimit($event, 'loss limit link')"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.svoc.166.level2.header3'
                                    | translate
                                        : {
                                              amount: svocAffordabilityErrorDetails?.netDepLimit | vnCurrency: currencyGBP,
                                              url: svocAffordabilityErrorDetails?.lossLimitFaqLink,
                                          }
                            "></strong>
                        <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.svoc.166.level1.msg1' | translate"></p>
                        <p
                            class="line-space"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.183.deposit.affordibility.limit.to.be.exceeded.msg5'
                                    | translate
                                        : {
                                              remainingamount:
                                                  svocAffordabilityErrorDetails?.allowedAmt?.value
                                                  | vnCurrency: svocAffordabilityErrorDetails?.allowedAmt?.currencyCode,
                                          }
                            "></p>
                        <p
                            class="line-space"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.deposit.affordibility.annualized.limit.msg2'
                                    | translate: { contactEmail: svocAffordabilityErrorDetails?.contactEmail }
                            "></p>
                    </div>
                </show-message>
            }
        }
    </div>
}
@if (affordabilityQuestionaireLimit) {
    <show-message id="affordabilityQuestionaire" [type]="messageType.INFO">
        <div info>
            <strong>{{ 'PARTY.CASHIER.web.175.3k.milestone.limit.reached.msg1' | translate }}</strong>
            <p class="line-space" [vnDynamicHtml]="'PARTY.CASHIER.web.179.milestone.limit.exceeded.msg2' | translate"></p>
            <p class="line-space">{{ 'PARTY.CASHIER.web.179.milestone.limit.exceeded.msg3' | translate }}</p>
        </div>
    </show-message>
    <div class="space-between mb-2">
        <a
            (click)="startButtonClick()"
            href="{{ affordabilityQuestionaireLimit?.sgqLink }}"
            target="_top"
            type="button"
            class="btn btn-primary d-flex align-items-center">
            {{ 'PARTY.CASHIER.web.175.3k.milestone.limit.reached.msg4' | translate }}
        </a>
        <a
            href="{{ affordabilityQuestionaireLimit?.increaseLimitsUrl }}"
            (click)="checkMyLimits()"
            target="_top"
            type="button"
            class="btn btn-primary d-flex align-items-center">
            {{ 'PARTY.CASHIER.web.deposit.affordibility.check.myLimits' | translate }}
        </a>
    </div>
}
@if (rolling30dayLossLimitDetails) {
    @if (['AFF_L5/6_LIMIT_U25_EXCEEDED', 'AFF_L5/6_LIMIT_A25_EXCEEDED'].includes(rolling30dayLossLimitDetails?.errorMessage?.toUpperCase())) {
        <show-message id="rolling30dayLossLimitDetails" [type]="messageType.ERROR">
            <div error>
                <strong
                    (click)="lossLimitLink($event, 'loss limit link')"
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.191.deposit.affordibility.limit.exceeded.text1'
                            | translate
                                : {
                                      amount: rolling30dayLossLimitDetails?.netDepLimit | vnCurrency: currencyGBP,
                                      url: rolling30dayLossLimitDetails?.lossLimitFaqLink,
                                  }
                    "></strong>
                <p
                    class="line-space"
                    (click)="lossLimitLink($event, null)"
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.191.deposit.affordibility.limit.exceeded.text2'
                            | translate: { url: rolling30dayLossLimitDetails?.lossLimitFaqLink }
                    "></p>
                <p class="line-space">{{ 'PARTY.CASHIER.web.191.deposit.affordibility.limit.exceeded.text3' | translate }}</p>
            </div>
        </show-message>
        <a
            href="{{ rolling30dayLossLimitDetails?.increaseLimitsUrl }}"
            (click)="checkMyLimits()"
            target="_top"
            type="button"
            class="btn btn-primary w-100 mb-2">
            {{ 'PARTY.CASHIER.web.deposit.affordibility.check.myLimits' | translate }}
        </a>
    }
    @if (
        ['AFF_L5/6_LIMIT_U25_TO_BE_EXCEEDED', 'AFF_L5/6_LIMIT_A25_TO_BE_EXCEEDED'].includes(rolling30dayLossLimitDetails?.errorMessage?.toUpperCase())
    ) {
        <show-message id="rolling30dayLossLimitDetails" [type]="messageType.INFO">
            <div info>
                <strong
                    (click)="lossLimitLink($event, 'loss limit link')"
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.191.deposit.affordibility.limit.tobeExceeded.text1'
                            | translate
                                : {
                                      amount: rolling30dayLossLimitDetails?.netDepLimit | vnCurrency: currencyGBP,
                                      url: rolling30dayLossLimitDetails?.lossLimitFaqLink,
                                  }
                    "></strong>
                <p
                    class="line-space"
                    (click)="lossLimitLink($event, null)"
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.191.deposit.affordibility.limit.exceeded.text2'
                            | translate: { url: rolling30dayLossLimitDetails?.lossLimitFaqLink }
                    "></p>
                <p class="line-space">
                    {{
                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.to.be.exceeded.msg4'
                            | translate
                                : {
                                      remainingamount:
                                          rolling30dayLossLimitDetails?.allowedAmt?.value
                                          | vnCurrency: rolling30dayLossLimitDetails?.allowedAmt?.currencyCode,
                                  }
                    }}
                </p>
                <p class="line-space">{{ 'PARTY.CASHIER.web.191.deposit.affordibility.limit.exceeded.text3' | translate }}</p>
            </div>
        </show-message>
        <a
            href="{{ rolling30dayLossLimitDetails?.increaseLimitsUrl }}"
            (click)="checkMyLimits()"
            target="_top"
            type="button"
            class="btn btn-primary w-100 mb-2">
            {{ 'PARTY.CASHIER.web.deposit.affordibility.check.myLimits' | translate }}
        </a>
    }
}

@if (maxLossLimitMonthlyExceededErrorDetails) {
    @if (response?.errorResponse?.errorMessage == 'MAX_LOSS_LIMIT_MONTHLY_EXCEEDED') {
        <show-message id="maxLossLimitExceeded" [type]="messageType.ERROR">
            <div error>
                <strong>{{ 'PARTY.CASHIER.web.deposit.maxlosslimit.reached.header' | translate }}</strong>
                <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.maxlosslimit.reached.msg' | translate }}</p>
            </div>
        </show-message>
        <a
            (click)="lossLimitLink($event, 'review my settings')"
            href="{{ maxLossLimitMonthlyExceededErrorDetails?.increaseLimitsUrl }}"
            target="_top"
            type="button"
            class="btn btn-primary mb-2 w-100">
            {{ 'PARTY.CASHIER.web.deposit.maxlosslimit.reviewMySettings' | translate }}
        </a>
    }
    @if (response?.errorResponse?.errorMessage == 'MAX_LOSS_LIMIT_MONTHLY_TO_BE_EXCEEDED') {
        <show-message id="maxLossLimitToBeExceeded" [type]="messageType.INFO">
            <div info>
                <strong>{{ 'PARTY.CASHIER.web.deposit.maxlosslimit.tobeReached.header' | translate }}</strong>
                <p class="line-space">
                    {{
                        'PARTY.CASHIER.web.deposit.maxlosslimit.tobeReached.msg1'
                            | translate
                                : {
                                      remainingamount:
                                          maxLossLimitMonthlyExceededErrorDetails?.allowedAmt?.value
                                          | vnCurrency: maxLossLimitMonthlyExceededErrorDetails?.allowedAmt?.currencyCode,
                                  }
                    }}
                </p>
                <p
                    class="line-space"
                    (click)="lossLimitLink($event, 'max loss limit link')"
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.deposit.maxlosslimit.tobeReached.msg2'
                            | translate: { url: maxLossLimitMonthlyExceededErrorDetails?.increaseLimitsUrl }
                    "></p>
            </div>
        </show-message>
    }
}
@if (frarolling90dayLossLimitDetails) {
    @if (
        ['FRA_LIMIT_UNDER25_EXCEEDED', 'FRA_LIMIT_OVER25_EXCEEDED', 'FRA_LIMIT_OVER80_EXCEEDED'].includes(
            frarolling90dayLossLimitDetails?.errorMessage?.toUpperCase()
        )
    ) {
        <show-message id="frarolling90dayLossLimitDetails" [type]="messageType.ERROR">
            <div error>
                <strong>{{ 'PARTY.CASHIER.web.187.deposit.affordibility.limit.header' | translate }}</strong>
                <p class="line-space">{{ 'PARTY.CASHIER.web.fra.deposit.affordibility.limit.exceeded.msg1' | translate }}</p>
                <p
                    class="line-space"
                    (click)="contactUsLink($event, 'chat with us link')"
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.176.8k.milestone.to.be.limit.reached.msg4' | translate: { url: frarolling90dayLossLimitDetails?.contactUs }
                    "></p>
            </div>
        </show-message>
        <a
            href="{{ frarolling90dayLossLimitDetails?.selfCertLink }}"
            target="_top"
            type="button"
            class="btn btn-primary w-100 mb-2"
            (click)="startQuestionnaire()"
            id="selfcertlink">
            {{ 'PARTY.CASHIER.web.176.8k.milestone.to.be.limit.reached.msg5' | translate }}
        </a>
    }
    @if (
        ['FRA_LIMIT_UNDER25_TO_BE_EXCEEDED', 'FRA_LIMIT_OVER25_TO_BE_EXCEEDED', 'FRA_LIMIT_OVER80_TO_BE_EXCEEDED'].includes(
            frarolling90dayLossLimitDetails?.errorMessage?.toUpperCase()
        )
    ) {
        <show-message id="frarolling90dayLossLimitDetails" [type]="messageType.INFO">
            <div info>
                <strong>{{ 'PARTY.CASHIER.web.187.deposit.affordibility.limit.header' | translate }}</strong>
                <p
                    class="line-space"
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.fra.deposit.affordibility.limit.tobe.exceeded.msg1'
                            | translate
                                : {
                                      amount:
                                          frarolling90dayLossLimitDetails?.limit
                                          | vnCurrency: frarolling90dayLossLimitDetails?.allowedAmt?.currencyCode,
                                      rollingPeriod: affFraRollingPeriod,
                                  }
                    "></p>
                <p class="line-space">
                    {{
                        'PARTY.CASHIER.web.181.deposit.affordibility.limit.to.be.exceeded.msg4'
                            | translate
                                : {
                                      remainingamount:
                                          frarolling90dayLossLimitDetails?.allowedAmt?.value
                                          | vnCurrency: frarolling90dayLossLimitDetails?.allowedAmt?.currencyCode,
                                  }
                    }}
                </p>
            </div>
        </show-message>
    }
}
@if (svocPurchaseLimitsErrorDetails) {
    @if (svocPurchaseLimitsErrorDetails?.allowedAmt?.value > 0) {
        <show-message [type]="messageType.INFO">
            <div info>
                <strong>{{
                    'PARTY.CASHIER.web.deposit.svoc.purchaseLimit.tobeReached.header'
                        | translate: { paymentMethod: paymentMethod, frequency: frequency }
                }}</strong>
                <p
                    class="line-space"
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.deposit.svoc.purchaseLimit.tobeReached.text'
                            | translate
                                : {
                                      remainingAmount:
                                          svocPurchaseLimitsErrorDetails?.allowedAmt?.value
                                          | vnCurrency: svocPurchaseLimitsErrorDetails?.allowedAmt?.currencyCode : '1.0',
                                      url: svocPurchaseLimitsErrorDetails?.findOutMoreUrl,
                                  }
                    "></p>
            </div>
        </show-message>
    } @else {
        <show-message [type]="messageType.ERROR">
            <div error>
                <strong>
                    {{
                        'PARTY.CASHIER.web.deposit.svoc.purchaseLimit.reached.header'
                            | translate: { paymentMethod: paymentMethod, frequency: frequency }
                    }}</strong
                >
                <p
                    class="line-space"
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.deposit.svoc.purchaseLimit.reached.text'
                            | translate: { url: svocPurchaseLimitsErrorDetails?.findOutMoreUrl }
                    "></p>
            </div>
        </show-message>
    }
}
@if (svoctxnLimitErrorDetails) {
    <show-message [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.svoc.purchaseLimit.txnExceeded.header' | translate: { frequency, paymentMethod } }}</strong>
            <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.svoc.purchaseLimit.txnExceeded.txt' | translate }}</p>
        </div>
    </show-message>
}
@if (defaultError) {
    <show-message id="defaultError" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.error.header' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.deposit.error.description' | translate }}</p>
        </div>
    </show-message>
}
